import {
  createRequestTypes,
  START,
  SUCCESS,
  ERROR,
} from '@modules/appraisal/actions/global';
import { makeApiActionCreatorV3 } from '@actions/utils';
import * as eventApi from '@modules/events/api/event';
import * as api from '../api/appeals';

const namespace = 'APPEALS';

export const FETCH_CURRENT_APPEAL_YEAR = createRequestTypes(
  `${namespace}/FETCH_CURRENT_APPEAL_YEAR`,
);

export const fetchCurrentAppealYear = makeApiActionCreatorV3(
  api.fetchCurrentAppealYear,
  FETCH_CURRENT_APPEAL_YEAR[START],
  FETCH_CURRENT_APPEAL_YEAR[SUCCESS],
  FETCH_CURRENT_APPEAL_YEAR[ERROR],
);

export const SEARCH_APPEALS = createRequestTypes(`${namespace}/SEARCH_APPEALS`);

export const searchAppeals = makeApiActionCreatorV3(
  api.searchAppeals,
  SEARCH_APPEALS[START],
  SEARCH_APPEALS[SUCCESS],
  SEARCH_APPEALS[ERROR],
);

export const FETCH_APPEALS_EMAILS = createRequestTypes(
  `${namespace}/FETCH_APPEALS_EMAILS`,
);

export const fetchAppealsEmails = makeApiActionCreatorV3(
  api.fetchAppealsEmails,
  FETCH_APPEALS_EMAILS[START],
  FETCH_APPEALS_EMAILS[SUCCESS],
  FETCH_APPEALS_EMAILS[ERROR],
);

export const SEARCH_APPEALS_EXPORT = createRequestTypes(
  `${namespace}/SEARCH_APPEALS_EXPORT`,
);

export const searchAppealsExport = makeApiActionCreatorV3(
  api.searchAppealsExport,
  SEARCH_APPEALS_EXPORT[START],
  SEARCH_APPEALS_EXPORT[SUCCESS],
  SEARCH_APPEALS_EXPORT[ERROR],
);

export const DOWNLOAD_APPEAL_FILE = createRequestTypes(
  `${namespace}/DOWNLOAD_APPEAL_FILE`,
);

export const downloadAppealFile = makeApiActionCreatorV3(
  api.downloadAppealFile,
  DOWNLOAD_APPEAL_FILE[START],
  DOWNLOAD_APPEAL_FILE[SUCCESS],
  DOWNLOAD_APPEAL_FILE[ERROR],
);

export const SEARCH_APPEALS_STANDALONE = createRequestTypes(
  `${namespace}/SEARCH_APPEALS_STANDALONE`,
);

export const searchAppealsStandalone = makeApiActionCreatorV3(
  api.searchAppealsStandalone,
  SEARCH_APPEALS_STANDALONE[START],
  SEARCH_APPEALS_STANDALONE[SUCCESS],
  SEARCH_APPEALS_STANDALONE[ERROR],
);

export const FETCH_SEARCH_RESULTS_CONFIG = createRequestTypes(
  `${namespace}/FETCH_SEARCH_RESULTS_CONFIG`,
);
export const fetchSearchResultsConfig = makeApiActionCreatorV3(
  api.fetchSearchResultsConfig,
  FETCH_SEARCH_RESULTS_CONFIG[START],
  FETCH_SEARCH_RESULTS_CONFIG[SUCCESS],
  FETCH_SEARCH_RESULTS_CONFIG[ERROR],
);

export const FETCH_APPEALS_UPDATE_CONFIG = createRequestTypes(
  `${namespace}/FETCH_APPEALS_UPDATE_CONFIG`,
);
export const fetchAppealsUpdateConfig = makeApiActionCreatorV3(
  api.fetchAppealsUpdateConfig,
  FETCH_APPEALS_UPDATE_CONFIG[START],
  FETCH_APPEALS_UPDATE_CONFIG[SUCCESS],
  FETCH_APPEALS_UPDATE_CONFIG[ERROR],
);

export const CHANGE_PAGE = `${namespace}/CHANGE_PAGE`;

export const changePage = (page) => ({
  type: CHANGE_PAGE,
  payload: page,
});

export const CHANGE_ROWS_PER_PAGE = `${namespace}/CHANGE_ROWS_PER_PAGE`;

export const changeRowsPerPage = (rowsPerPage) => ({
  type: CHANGE_ROWS_PER_PAGE,
  payload: rowsPerPage,
});

export const FETCH_CODE_FILE = createRequestTypes(
  `${namespace}/FETCH_CODE_FILE`,
);

export const fetchCodeFile = makeApiActionCreatorV3(
  api.fetchCodeFile,
  FETCH_CODE_FILE[START],
  FETCH_CODE_FILE[SUCCESS],
  FETCH_CODE_FILE[ERROR],
);

export const FETCH_APPRAISERS = createRequestTypes(
  `${namespace}/FETCH_APPRAISERS`,
);

export const fetchAppraisers = makeApiActionCreatorV3(
  api.fetchAppraisers,
  FETCH_APPRAISERS[START],
  FETCH_APPRAISERS[SUCCESS],
  FETCH_APPRAISERS[ERROR],
);

export const FETCH_USERS = createRequestTypes(`${namespace}/FETCH_USERS`);

export const fetchUsers = makeApiActionCreatorV3(
  api.fetchUsers,
  FETCH_USERS[START],
  FETCH_USERS[SUCCESS],
  FETCH_USERS[ERROR],
);

export const FETCH_STATISTICS = createRequestTypes(
  `${namespace}/FETCH_STATISTICS`,
);

export const fetchStatistics = makeApiActionCreatorV3(
  api.fetchStatistics,
  FETCH_STATISTICS[START],
  FETCH_STATISTICS[SUCCESS],
  FETCH_STATISTICS[ERROR],
);

export const FETCH_APPEALS_HEADER = createRequestTypes(
  `${namespace}/FETCH_APPEALS_HEADER`,
);

export const fetchAppealsHeader = makeApiActionCreatorV3(
  api.fetchAppealsHeader,
  FETCH_APPEALS_HEADER[START],
  FETCH_APPEALS_HEADER[SUCCESS],
  FETCH_APPEALS_HEADER[ERROR],
);

export const FETCH_APPEAL_GENERAL_INFO = createRequestTypes(
  `${namespace}/FETCH_APPEAL_GENERAL_INFO`,
);

export const fetchAppealGeneralInfo = makeApiActionCreatorV3(
  api.fetchAppealGeneralInfo,
  FETCH_APPEAL_GENERAL_INFO[START],
  FETCH_APPEAL_GENERAL_INFO[SUCCESS],
  FETCH_APPEAL_GENERAL_INFO[ERROR],
);

export const UPDATE_APPEAL_GENERAL_INFO = createRequestTypes(
  `${namespace}/UPDATE_APPEAL_GENERAL_INFO`,
);

export const updateAppealGeneralInfo = makeApiActionCreatorV3(
  api.updateAppealGeneralInfo,
  UPDATE_APPEAL_GENERAL_INFO[START],
  UPDATE_APPEAL_GENERAL_INFO[SUCCESS],
  UPDATE_APPEAL_GENERAL_INFO[ERROR],
);

export const FETCH_APPEAL_GENERAL_INFO_NO_REFRESH = createRequestTypes(
  `${namespace}/FETCH_APPEAL_GENERAL_INFO_NO_REFRESH`,
);

export const fetchAppealGeneralInfoNoRefresh = makeApiActionCreatorV3(
  api.fetchAppealGeneralInfo,
  FETCH_APPEAL_GENERAL_INFO_NO_REFRESH[START],
  FETCH_APPEAL_GENERAL_INFO_NO_REFRESH[SUCCESS],
  FETCH_APPEAL_GENERAL_INFO_NO_REFRESH[ERROR],
);

export const FETCH_APPEALS_SUMMARY = createRequestTypes(
  `${namespace}/FETCH_APPEALS_SUMMARY`,
);

export const fetchAppealsSummary = makeApiActionCreatorV3(
  api.fetchAppealsSummary,
  FETCH_APPEALS_SUMMARY[START],
  FETCH_APPEALS_SUMMARY[SUCCESS],
  FETCH_APPEALS_SUMMARY[ERROR],
);

export const FETCH_APPEALS_SUMMARY_NO_REFRESH = createRequestTypes(
  `${namespace}/FETCH_APPEALS_SUMMARY_NO_REFRESH`,
);

export const fetchAppealsSummaryNoRefresh = makeApiActionCreatorV3(
  api.fetchAppealsSummary,
  FETCH_APPEALS_SUMMARY_NO_REFRESH[START],
  FETCH_APPEALS_SUMMARY_NO_REFRESH[SUCCESS],
  FETCH_APPEALS_SUMMARY_NO_REFRESH[ERROR],
);

export const UPDATE_APPEALS_SUMMARY = createRequestTypes(
  `${namespace}/UPDATE_APPEALS_SUMMARY`,
);

export const updateAppealsSummary = makeApiActionCreatorV3(
  api.updateAppealsSummary,
  UPDATE_APPEALS_SUMMARY[START],
  UPDATE_APPEALS_SUMMARY[SUCCESS],
  UPDATE_APPEALS_SUMMARY[ERROR],
);

export const FETCH_APPEAL_REASONS = createRequestTypes(
  `${namespace}/FETCH_APPEAL_REASONS`,
);

export const fetchAppealReasons = makeApiActionCreatorV3(
  api.fetchAppealReasons,
  FETCH_APPEAL_REASONS[START],
  FETCH_APPEAL_REASONS[SUCCESS],
  FETCH_APPEAL_REASONS[ERROR],
);

export const UPDATE_APPEAL_REASONS = createRequestTypes(
  `${namespace}/UPDATE_APPEAL_REASONS`,
);

export const updateAppealReasons = makeApiActionCreatorV3(
  api.updateAppealReasons,
  UPDATE_APPEAL_REASONS[START],
  UPDATE_APPEAL_REASONS[SUCCESS],
  UPDATE_APPEAL_REASONS[ERROR],
);

export const FETCH_APPEAL_TAGS = createRequestTypes(
  `${namespace}/FETCH_APPEAL_TAGS`,
);

export const fetchAppealTags = makeApiActionCreatorV3(
  api.fetchAppealTags,
  FETCH_APPEAL_TAGS[START],
  FETCH_APPEAL_TAGS[SUCCESS],
  FETCH_APPEAL_TAGS[ERROR],
);

export const UPDATE_APPEAL_TAGS = createRequestTypes(
  `${namespace}/UPDATE_APPEAL_TAGS`,
);

export const updateAppealTags = makeApiActionCreatorV3(
  api.updateAppealTags,
  UPDATE_APPEAL_TAGS[START],
  UPDATE_APPEAL_TAGS[SUCCESS],
  UPDATE_APPEAL_TAGS[ERROR],
);

export const FETCH_CLAIMANT_INFO = createRequestTypes(
  `${namespace}/FETCH_CLAIMANT_INFO`,
);

export const fetchClaimantInfo = makeApiActionCreatorV3(
  api.fetchClaimantInfo,
  FETCH_CLAIMANT_INFO[START],
  FETCH_CLAIMANT_INFO[SUCCESS],
  FETCH_CLAIMANT_INFO[ERROR],
);

export const FETCH_AFFIDAVIT_INFO = createRequestTypes(
  `${namespace}/FETCH_AFFIDAVIT_INFO`,
);

export const fetchAffidavitInfo = makeApiActionCreatorV3(
  api.fetchAffidavitInfo,
  FETCH_AFFIDAVIT_INFO[START],
  FETCH_AFFIDAVIT_INFO[SUCCESS],
  FETCH_AFFIDAVIT_INFO[ERROR],
);

export const INSERT_FILE = createRequestTypes(`${namespace}/INSERT_FILE`);
export const insertFile = makeApiActionCreatorV3(
  api.insertFile,
  INSERT_FILE[START],
  INSERT_FILE[SUCCESS],
  INSERT_FILE[ERROR],
);

export const SET_FILE_TYPE = createRequestTypes(`${namespace}/SET_FILE_TYPE`);
export const setFileType = makeApiActionCreatorV3(
  api.setFileType,
  SET_FILE_TYPE[START],
  SET_FILE_TYPE[SUCCESS],
  SET_FILE_TYPE[ERROR],
);

export const DELETE_FILE = createRequestTypes(`${namespace}/DELETE_FILE`);
export const deleteFile = makeApiActionCreatorV3(
  api.deleteFile,
  DELETE_FILE[START],
  DELETE_FILE[SUCCESS],
  DELETE_FILE[ERROR],
);

export const DOWNLOAD_FILE = createRequestTypes(`${namespace}/DOWNLOAD_FILE`);
export const downloadFile = makeApiActionCreatorV3(
  api.downloadFile,
  DOWNLOAD_FILE[START],
  DOWNLOAD_FILE[SUCCESS],
  DOWNLOAD_FILE[ERROR],
);

export const FETCH_DUE_DILIGENCE = createRequestTypes(
  `${namespace}/FETCH_DUE_DILIGENCE`,
);

export const fetchDueDiligence = makeApiActionCreatorV3(
  api.fetchDueDiligence,
  FETCH_DUE_DILIGENCE[START],
  FETCH_DUE_DILIGENCE[SUCCESS],
  FETCH_DUE_DILIGENCE[ERROR],
);

export const UPDATE_DUE_DILIGENCE = createRequestTypes(
  `${namespace}/UPDATE_DUE_DILIGENCE`,
);

export const updateDueDiligence = makeApiActionCreatorV3(
  api.updateDueDiligence,
  UPDATE_DUE_DILIGENCE[START],
  UPDATE_DUE_DILIGENCE[SUCCESS],
  UPDATE_DUE_DILIGENCE[ERROR],
);

export const updateDueDiligenceComments = makeApiActionCreatorV3(
  api.updateDueDiligenceComments,
  UPDATE_DUE_DILIGENCE[START],
  UPDATE_DUE_DILIGENCE[SUCCESS],
  UPDATE_DUE_DILIGENCE[ERROR],
);

export const FETCH_INFORMAL = createRequestTypes(`${namespace}/FETCH_INFORMAL`);

export const fetchAppealInformal = makeApiActionCreatorV3(
  api.fetchAppealInformal,
  FETCH_INFORMAL[START],
  FETCH_INFORMAL[SUCCESS],
  FETCH_INFORMAL[ERROR],
);

export const UPDATE_INFORMAL = createRequestTypes(
  `${namespace}/UPDATE_INFORMAL`,
);

export const updateAppealInformal = makeApiActionCreatorV3(
  api.updateAppealInformal,
  UPDATE_INFORMAL[START],
  UPDATE_INFORMAL[SUCCESS],
  UPDATE_INFORMAL[ERROR],
);

export const FETCH_PRIOR_YR_COMMENTS = createRequestTypes(
  `${namespace}/FETCH_PRIOR_YR_COMMENTS`,
);

export const fetchPriorYearComments = makeApiActionCreatorV3(
  api.fetchPriorYearComments,
  FETCH_PRIOR_YR_COMMENTS[START],
  FETCH_PRIOR_YR_COMMENTS[SUCCESS],
  FETCH_PRIOR_YR_COMMENTS[ERROR],
);

export const START_INFORMAL = createRequestTypes(`${namespace}/START_INFORMAL`);

export const startInformal = makeApiActionCreatorV3(
  api.startInformal,
  START_INFORMAL[START],
  START_INFORMAL[SUCCESS],
  START_INFORMAL[ERROR],
);

export const FINISH_INFORMAL = createRequestTypes(
  `${namespace}/FINISH_INFORMAL`,
);

export const finishInformal = makeApiActionCreatorV3(
  api.finishInformal,
  FINISH_INFORMAL[START],
  FINISH_INFORMAL[SUCCESS],
  FINISH_INFORMAL[ERROR],
);

export const START_FORMAL = createRequestTypes(`${namespace}/START_FORMAL`);

export const startFormal = makeApiActionCreatorV3(
  api.startFormal,
  START_FORMAL[START],
  START_FORMAL[SUCCESS],
  START_FORMAL[ERROR],
);

export const FINISH_FORMAL = createRequestTypes(`${namespace}/FINISH_FORMAL`);

export const finishFormal = makeApiActionCreatorV3(
  api.finishFormal,
  FINISH_FORMAL[START],
  FINISH_FORMAL[SUCCESS],
  FINISH_FORMAL[ERROR],
);

export const FETCH_FORMAL = createRequestTypes(`${namespace}/FETCH_FORMAL`);

export const fetchAppealFormal = makeApiActionCreatorV3(
  api.fetchAppealFormal,
  FETCH_FORMAL[START],
  FETCH_FORMAL[SUCCESS],
  FETCH_FORMAL[ERROR],
);

export const UPDATE_FORMAL = createRequestTypes(`${namespace}/UPDATE_FORMAL`);

export const updateAppealFormal = makeApiActionCreatorV3(
  api.updateAppealFormal,
  UPDATE_FORMAL[START],
  UPDATE_FORMAL[SUCCESS],
  UPDATE_FORMAL[ERROR],
);

export const PATCH_FORMAL = createRequestTypes(`${namespace}/PATCH_FORMAL`);

export const patchAppealFormal = makeApiActionCreatorV3(
  api.patchAppealFormal,
  PATCH_FORMAL[START],
  PATCH_FORMAL[SUCCESS],
  PATCH_FORMAL[ERROR],
);

export const FETCH_FINAL_VALUES = createRequestTypes(
  `${namespace}/FETCH_FINAL_VALUES`,
);

export const fetchAppealFinalValues = makeApiActionCreatorV3(
  api.fetchAppealFinalValues,
  FETCH_FINAL_VALUES[START],
  FETCH_FINAL_VALUES[SUCCESS],
  FETCH_FINAL_VALUES[ERROR],
);
export const UPDATE_FINAL_VALUES = createRequestTypes(
  `${namespace}/UPDATE_FINAL_VALUES`,
);

export const updateAppealFinalValues = makeApiActionCreatorV3(
  api.updateAppealFinalValues,
  UPDATE_FINAL_VALUES[START],
  UPDATE_FINAL_VALUES[SUCCESS],
  UPDATE_FINAL_VALUES[ERROR],
);
export const FINALIZE_FINAL_VALUES = createRequestTypes(
  `${namespace}/FINALIZE_FINAL_VALUES`,
);

export const finalizeAppealFinalValues = makeApiActionCreatorV3(
  api.finalizeAppealFinalValues,
  FINALIZE_FINAL_VALUES[START],
  FINALIZE_FINAL_VALUES[SUCCESS],
  FINALIZE_FINAL_VALUES[ERROR],
);

export const FETCH_GLOBAL_DOCUMENTS = createRequestTypes(
  `${namespace}/FETCH_GLOBAL_DOCUMENTS`,
);

export const fetchGlobalDocuments = makeApiActionCreatorV3(
  api.fetchGlobalDocuments,
  FETCH_GLOBAL_DOCUMENTS[START],
  FETCH_GLOBAL_DOCUMENTS[SUCCESS],
  FETCH_GLOBAL_DOCUMENTS[ERROR],
);

export const FETCH_PRESENTATION_DOCUMENTS = createRequestTypes(
  `${namespace}/FETCH_PRESENTATION_DOCUMENTS`,
);

export const fetchAppealsPresentationDocuments = makeApiActionCreatorV3(
  api.fetchAppealsPresentationDocuments,
  FETCH_PRESENTATION_DOCUMENTS[START],
  FETCH_PRESENTATION_DOCUMENTS[SUCCESS],
  FETCH_PRESENTATION_DOCUMENTS[ERROR],
);

export const SET_PRESENTATION_ORDER = createRequestTypes(
  `${namespace}/SET_PRESENTATION_ORDER`,
);

export const setPresentationDocumentOrder = makeApiActionCreatorV3(
  api.setPresentationDocumentOrder,
  SET_PRESENTATION_ORDER[START],
  SET_PRESENTATION_ORDER[SUCCESS],
  SET_PRESENTATION_ORDER[ERROR],
);

export const INSERT_PRESENTATION_DOCUMENT = createRequestTypes(
  `${namespace}/INSERT_PRESENTATION_DOCUMENT`,
);

export const insertPresentationDocument = makeApiActionCreatorV3(
  api.insertPresentationDocument,
  INSERT_PRESENTATION_DOCUMENT[START],
  INSERT_PRESENTATION_DOCUMENT[SUCCESS],
  INSERT_PRESENTATION_DOCUMENT[ERROR],
);

export const INSERT_PRESENTATION_DOCUMENT_BY_S3 = createRequestTypes(
  `${namespace}/INSERT_PRESENTATION_DOCUMENT_BY_S3`,
);

export const insertPresentationDocumentByS3 = makeApiActionCreatorV3(
  api.insertPresentationDocumentByS3,
  INSERT_PRESENTATION_DOCUMENT_BY_S3[START],
  INSERT_PRESENTATION_DOCUMENT_BY_S3[SUCCESS],
  INSERT_PRESENTATION_DOCUMENT_BY_S3[ERROR],
);

export const INSERT_PRESENTATION_DOCUMENT_GENERATE = createRequestTypes(
  `${namespace}/INSERT_PRESENTATION_DOCUMENT_GENERATE`,
);

export const insertPresentationDocumentGenerate = makeApiActionCreatorV3(
  api.insertPresentationDocumentGenerate,
  INSERT_PRESENTATION_DOCUMENT_GENERATE[START],
  INSERT_PRESENTATION_DOCUMENT_GENERATE[SUCCESS],
  INSERT_PRESENTATION_DOCUMENT_GENERATE[ERROR],
);

export const DOWNLOAD_GLOBAL_DOC = createRequestTypes(
  `${namespace}/DOWNLOAD_GLOBAL_DOC`,
);

export const downloadGlobalDocument = makeApiActionCreatorV3(
  api.downloadGlobalDocument,
  DOWNLOAD_GLOBAL_DOC[START],
  DOWNLOAD_GLOBAL_DOC[SUCCESS],
  DOWNLOAD_GLOBAL_DOC[ERROR],
);

export const FETCH_APPEAL_PRESENTATION = createRequestTypes(
  `${namespace}/FETCH_APPEAL_PRESENTATION`,
);

export const fetchAppealsPresentation = makeApiActionCreatorV3(
  api.fetchAppealsPresentation,
  FETCH_APPEAL_PRESENTATION[START],
  FETCH_APPEAL_PRESENTATION[SUCCESS],
  FETCH_APPEAL_PRESENTATION[ERROR],
);

export const DELETE_APPEAL_PRESENTATION = createRequestTypes(
  `${namespace}/DELETE_APPEAL_PRESENTATION`,
);

export const deleteAppealsPresentation = makeApiActionCreatorV3(
  api.deleteAppealsPresentation,
  DELETE_APPEAL_PRESENTATION[START],
  DELETE_APPEAL_PRESENTATION[SUCCESS],
  DELETE_APPEAL_PRESENTATION[ERROR],
);

export const DOWNLOAD_PRESENTATION_FILE = createRequestTypes(
  `${namespace}/DOWNLOAD_PRESENTATION_FILE`,
);

export const downloadPresentationFile = makeApiActionCreatorV3(
  api.downloadPresentationFile,
  DOWNLOAD_PRESENTATION_FILE[START],
  DOWNLOAD_PRESENTATION_FILE[SUCCESS],
  DOWNLOAD_PRESENTATION_FILE[ERROR],
);

export const VIEW_PRESENTATION_FILE = createRequestTypes(
  `${namespace}/VIEW_PRESENTATION_FILE`,
);

export const viewPresentationFile = makeApiActionCreatorV3(
  api.viewPresentationFile,
  VIEW_PRESENTATION_FILE[START],
  VIEW_PRESENTATION_FILE[SUCCESS],
  VIEW_PRESENTATION_FILE[ERROR],
);

export const PUBLISH_APPEAL_PRESENTATION = createRequestTypes(
  `${namespace}/PUBLISH_APPEAL_PRESENTATION`,
);

export const publishAppealsPresentation = makeApiActionCreatorV3(
  api.publishAppealsPresentation,
  PUBLISH_APPEAL_PRESENTATION[START],
  PUBLISH_APPEAL_PRESENTATION[SUCCESS],
  PUBLISH_APPEAL_PRESENTATION[ERROR],
);

export const FETCH_PRESENTATION_FILE = createRequestTypes(
  `${namespace}/FETCH_PRESENTATION_FILE`,
);

export const fetchPresentationFile = makeApiActionCreatorV3(
  api.fetchPresentationFile,
  FETCH_PRESENTATION_FILE[START],
  FETCH_PRESENTATION_FILE[SUCCESS],
  FETCH_PRESENTATION_FILE[ERROR],
);

export const GET_APPEAL_INCOME_ACTUAL = createRequestTypes(
  `${namespace}/GET_APPEAL_INCOME_ACTUAL`,
);

export const getAppealIncomeActual = makeApiActionCreatorV3(
  api.getAppealIncomeActual,
  GET_APPEAL_INCOME_ACTUAL[START],
  GET_APPEAL_INCOME_ACTUAL[SUCCESS],
  GET_APPEAL_INCOME_ACTUAL[ERROR],
);

export const GET_APPEAL_INCOME_MODEL = createRequestTypes(
  `${namespace}/GET_APPEAL_INCOME_MODEL`,
);

export const getAppealIncomeModel = makeApiActionCreatorV3(
  api.getAppealIncomeModel,
  GET_APPEAL_INCOME_MODEL[START],
  GET_APPEAL_INCOME_MODEL[SUCCESS],
  GET_APPEAL_INCOME_MODEL[ERROR],
);

export const DELETE_PRESENTATION_DOCUMENT = createRequestTypes(
  `${namespace}/DELETE_PRESENTATION_DOCUMENT`,
);

export const deleteAppealsPresentationDocument = makeApiActionCreatorV3(
  api.deleteAppealsPresentationDocument,
  DELETE_PRESENTATION_DOCUMENT[START],
  DELETE_PRESENTATION_DOCUMENT[SUCCESS],
  DELETE_PRESENTATION_DOCUMENT[ERROR],
);

export const DOWNLOAD_PRESENTATION_DOCUMENT = createRequestTypes(
  `${namespace}/DOWNLOAD_PRESENTATION_DOCUMENT`,
);

export const downloadPresentationDocument = makeApiActionCreatorV3(
  api.downloadPresentationDocument,
  DOWNLOAD_PRESENTATION_DOCUMENT[START],
  DOWNLOAD_PRESENTATION_DOCUMENT[SUCCESS],
  DOWNLOAD_PRESENTATION_DOCUMENT[ERROR],
);

export const FETCH_APPEAL_PANEL_STATISTICS = createRequestTypes(
  `${namespace}/FETCH_APPEAL_PANEL_STATISTICS`,
);

export const fetchAppealPanelStatistics = makeApiActionCreatorV3(
  api.fetchAppealPanelStatistics,
  FETCH_APPEAL_PANEL_STATISTICS[START],
  FETCH_APPEAL_PANEL_STATISTICS[SUCCESS],
  FETCH_APPEAL_PANEL_STATISTICS[ERROR],
);

export const FETCH_APPEAL_PANEL_STATISTICS_DETAIL = createRequestTypes(
  `${namespace}/FETCH_APPEAL_PANEL_STATISTICS_DETAIL`,
);

export const fetchAppealPanelStatisticsDetail = makeApiActionCreatorV3(
  api.fetchAppealPanelStatisticsDetail,
  FETCH_APPEAL_PANEL_STATISTICS_DETAIL[START],
  FETCH_APPEAL_PANEL_STATISTICS_DETAIL[SUCCESS],
  FETCH_APPEAL_PANEL_STATISTICS_DETAIL[ERROR],
);

export const SET_PANEL_STATISTICS_MODE = `${namespace}/SET_PANEL_STATISTICS_MODE`;

export const setPanelStatisticsMode = (mode, modeOptions = {}) => ({
  type: SET_PANEL_STATISTICS_MODE,
  payload: {
    mode,
    modeOptions,
  },
});

export const FETCH_APPEAL_STAFF = createRequestTypes(
  `${namespace}/FETCH_APPEAL_STAFF`,
);

export const fetchAppealsStaff = makeApiActionCreatorV3(
  api.fetchAppealsStaff,
  FETCH_APPEAL_STAFF[START],
  FETCH_APPEAL_STAFF[SUCCESS],
  FETCH_APPEAL_STAFF[ERROR],
);

export const INSERT_APPEALS_STAFF = createRequestTypes(
  `${namespace}/INSERT_APPEALS_STAFF`,
);

export const insertAppealsStaff = makeApiActionCreatorV3(
  api.insertAppealsStaff,
  INSERT_APPEALS_STAFF[START],
  INSERT_APPEALS_STAFF[SUCCESS],
  INSERT_APPEALS_STAFF[ERROR],
);

export const DELETE_APPEALS_STAFF = createRequestTypes(
  `${namespace}/DELETE_APPEALS_STAFF`,
);

export const deleteAppealsStaff = makeApiActionCreatorV3(
  api.deleteAppealsStaff,
  DELETE_APPEALS_STAFF[START],
  DELETE_APPEALS_STAFF[SUCCESS],
  DELETE_APPEALS_STAFF[ERROR],
);

export const FETCH_APPEAL_DOCUMENTS = createRequestTypes(
  `${namespace}/FETCH_APPEAL_DOCUMENTS`,
);

export const fetchAppealDocuments = makeApiActionCreatorV3(
  api.fetchAppealDocuments,
  FETCH_APPEAL_DOCUMENTS[START],
  FETCH_APPEAL_DOCUMENTS[SUCCESS],
  FETCH_APPEAL_DOCUMENTS[ERROR],
);

export const DELETE_APPEAL_DOCUMENT = createRequestTypes(
  `${namespace}/DELETE_APPEAL_DOCUMENT`,
);

export const deleteAppealDocument = makeApiActionCreatorV3(
  api.deleteAppealDocument,
  DELETE_APPEAL_DOCUMENT[START],
  DELETE_APPEAL_DOCUMENT[SUCCESS],
  DELETE_APPEAL_DOCUMENT[ERROR],
);

export const INSERT_APPEAL_DOCUMENT = createRequestTypes(
  `${namespace}/INSERT_APPEAL_DOCUMENT`,
);

export const insertAppealDocument = makeApiActionCreatorV3(
  api.insertAppealDocument,
  INSERT_APPEAL_DOCUMENT[START],
  INSERT_APPEAL_DOCUMENT[SUCCESS],
  INSERT_APPEAL_DOCUMENT[ERROR],
);

export const UPDATE_APPEAL_DOCUMENT = createRequestTypes(
  `${namespace}/UPDATE_APPEAL_DOCUMENT`,
);

export const updateAppealDocument = makeApiActionCreatorV3(
  api.updateAppealDocument,
  UPDATE_APPEAL_DOCUMENT[START],
  UPDATE_APPEAL_DOCUMENT[SUCCESS],
  UPDATE_APPEAL_DOCUMENT[ERROR],
);

export const INSERT_APPEAL_DOC_FILE = createRequestTypes(
  `${namespace}/INSERT_APPEAL_DOC_FILE`,
);
export const insertAppealDocFile = makeApiActionCreatorV3(
  api.insertAppealDocFile,
  INSERT_APPEAL_DOC_FILE[START],
  INSERT_APPEAL_DOC_FILE[SUCCESS],
  INSERT_APPEAL_DOC_FILE[ERROR],
);

export const DELETE_APPEAL_DOC_FILE = createRequestTypes(
  `${namespace}/DELETE_APPEAL_DOC_FILE`,
);
export const deleteAppealDocFile = makeApiActionCreatorV3(
  api.deleteAppealDocFile,
  DELETE_APPEAL_DOC_FILE[START],
  DELETE_APPEAL_DOC_FILE[SUCCESS],
  DELETE_APPEAL_DOC_FILE[ERROR],
);

export const DOWNLOAD_APPEAL_DOC_FILE = createRequestTypes(
  `${namespace}/DOWNLOAD_APPEAL_DOC_FILE`,
);
export const downloadAppealDocFile = makeApiActionCreatorV3(
  api.downloadAppealDocFile,
  DOWNLOAD_APPEAL_DOC_FILE[START],
  DOWNLOAD_APPEAL_DOC_FILE[SUCCESS],
  DOWNLOAD_APPEAL_DOC_FILE[ERROR],
);

export const INSERT_APPEAL = createRequestTypes(`${namespace}/INSERT_APPEAL`);
export const insertAppeal = makeApiActionCreatorV3(
  api.insertAppeal,
  INSERT_APPEAL[START],
  INSERT_APPEAL[SUCCESS],
  INSERT_APPEAL[ERROR],
);

export const FETCH_APPEAL_CASE_PREP = createRequestTypes(
  `${namespace}/FETCH_APPEAL_CASE_PREP`,
);

export const fetchCasePrep = makeApiActionCreatorV3(
  api.fetchCasePrep,
  FETCH_APPEAL_CASE_PREP[START],
  FETCH_APPEAL_CASE_PREP[SUCCESS],
  FETCH_APPEAL_CASE_PREP[ERROR],
);

export const UPDATE_APPEAL_CASE_PREP = createRequestTypes(
  `${namespace}/UPDATE_APPEAL_CASE_PREP`,
);

export const updateCasePrep = makeApiActionCreatorV3(
  api.updateCasePrep,
  UPDATE_APPEAL_CASE_PREP[START],
  UPDATE_APPEAL_CASE_PREP[SUCCESS],
  UPDATE_APPEAL_CASE_PREP[ERROR],
);

export const FETCH_APPEAL_PANELS = createRequestTypes(
  `${namespace}/FETCH_APPEAL_PANELS`,
);

export const fetchPanels = makeApiActionCreatorV3(
  api.fetchPanels,
  FETCH_APPEAL_PANELS[START],
  FETCH_APPEAL_PANELS[SUCCESS],
  FETCH_APPEAL_PANELS[ERROR],
);

export const FETCH_APPEAL_PANEL = createRequestTypes(
  `${namespace}/FETCH_APPEAL_PANEL`,
);

export const fetchPanel = makeApiActionCreatorV3(
  api.fetchPanel,
  FETCH_APPEAL_PANEL[START],
  FETCH_APPEAL_PANEL[SUCCESS],
  FETCH_APPEAL_PANEL[ERROR],
);

export const FETCH_PANEL_BOARD_MEMBERS = createRequestTypes(
  `${namespace}/FETCH_PANEL_BOARD_MEMBERS`,
);

export const fetchBoardMembers = makeApiActionCreatorV3(
  api.fetchBoardMembers,
  FETCH_PANEL_BOARD_MEMBERS[START],
  FETCH_PANEL_BOARD_MEMBERS[SUCCESS],
  FETCH_PANEL_BOARD_MEMBERS[ERROR],
);

export const FETCH_ACTIVITY = createRequestTypes(`${namespace}/FETCH_ACTIVITY`);

export const fetchActivity = makeApiActionCreatorV3(
  api.fetchActivity,
  FETCH_ACTIVITY[START],
  FETCH_ACTIVITY[SUCCESS],
  FETCH_ACTIVITY[ERROR],
);

export const FETCH_APPEAL_BOARD_MEMBERS = createRequestTypes(
  `${namespace}/FETCH_APPEAL_BOARD_MEMBERS`,
);
export const fetchAppealBoardMembers = makeApiActionCreatorV3(
  api.fetchAppealBoardMembers,
  FETCH_APPEAL_BOARD_MEMBERS[START],
  FETCH_APPEAL_BOARD_MEMBERS[SUCCESS],
  FETCH_APPEAL_BOARD_MEMBERS[ERROR],
);

export const DELETE_APPEAL_BOARD_MEMBER = createRequestTypes(
  `${namespace}/DELETE_APPEAL_BOARD_MEMBER`,
);
export const deleteAppealBoardMember = makeApiActionCreatorV3(
  api.deleteAppealBoardMember,
  DELETE_APPEAL_BOARD_MEMBER[START],
  DELETE_APPEAL_BOARD_MEMBER[SUCCESS],
  DELETE_APPEAL_BOARD_MEMBER[ERROR],
);

export const FETCH_APPEAL_BOARD_MEMBER = createRequestTypes(
  `${namespace}/FETCH_APPEAL_BOARD_MEMBER`,
);
export const fetchAppealBoardMember = makeApiActionCreatorV3(
  api.fetchAppealBoardMember,
  FETCH_APPEAL_BOARD_MEMBER[START],
  FETCH_APPEAL_BOARD_MEMBER[SUCCESS],
  FETCH_APPEAL_BOARD_MEMBER[ERROR],
);

export const CODE_FILE_OFFICER_POSITIONS = createRequestTypes(
  `${namespace}/CODE_FILE_OFFICER_POSITIONS`,
);
export const codeFileOfficerPositions = makeApiActionCreatorV3(
  api.codeFileOfficerPositions,
  CODE_FILE_OFFICER_POSITIONS[START],
  CODE_FILE_OFFICER_POSITIONS[SUCCESS],
  CODE_FILE_OFFICER_POSITIONS[ERROR],
);

export const CODE_FILE_ROLES = createRequestTypes(
  `${namespace}/CODE_FILE_ROLES`,
);
export const codeFileRoles = makeApiActionCreatorV3(
  api.codeFileRoles,
  CODE_FILE_ROLES[START],
  CODE_FILE_ROLES[SUCCESS],
  CODE_FILE_ROLES[ERROR],
);

export const CODE_FILE_PREFERRED_COMMUNICATION = createRequestTypes(
  `${namespace}/CODE_FILE_PREFERRED_COMMUNICATION`,
);
export const codeFilePreferredCommunication = makeApiActionCreatorV3(
  api.codeFilePreferredCommunication,
  CODE_FILE_PREFERRED_COMMUNICATION[START],
  CODE_FILE_PREFERRED_COMMUNICATION[SUCCESS],
  CODE_FILE_PREFERRED_COMMUNICATION[ERROR],
);

export const INSERT_APPEAL_BOARD_MEMBER = createRequestTypes(
  `${namespace}/INSERT_APPEAL_BOARD_MEMBER`,
);
export const insertAppealBoardMember = makeApiActionCreatorV3(
  api.insertAppealBoardMember,
  INSERT_APPEAL_BOARD_MEMBER[START],
  INSERT_APPEAL_BOARD_MEMBER[SUCCESS],
  INSERT_APPEAL_BOARD_MEMBER[ERROR],
);

export const UPDATE_APPEAL_BOARD_MEMBER = createRequestTypes(
  `${namespace}/UPDATE_APPEAL_BOARD_MEMBER`,
);
export const updateAppealBoardMember = makeApiActionCreatorV3(
  api.updateAppealBoardMember,
  UPDATE_APPEAL_BOARD_MEMBER[START],
  UPDATE_APPEAL_BOARD_MEMBER[SUCCESS],
  UPDATE_APPEAL_BOARD_MEMBER[ERROR],
);

export const FETCH_APPEAL_PANEL_ROLES = createRequestTypes(
  `${namespace}/FETCH_APPEAL_PANEL_ROLES`,
);
export const fetchAppealPanelRoles = makeApiActionCreatorV3(
  api.fetchAppealPanelRoles,
  FETCH_APPEAL_PANEL_ROLES[START],
  FETCH_APPEAL_PANEL_ROLES[SUCCESS],
  FETCH_APPEAL_PANEL_ROLES[ERROR],
);

export const INSERT_APPEAL_PANEL = createRequestTypes(
  `${namespace}/INSERT_APPEAL_PANEL`,
);
export const insertAppealPanel = makeApiActionCreatorV3(
  api.insertAppealPanel,
  INSERT_APPEAL_PANEL[START],
  INSERT_APPEAL_PANEL[SUCCESS],
  INSERT_APPEAL_PANEL[ERROR],
);

export const UPDATE_APPEAL_PANEL = createRequestTypes(
  `${namespace}/UPDATE_APPEAL_PANEL`,
);
export const updateAppealPanel = makeApiActionCreatorV3(
  api.updateAppealPanel,
  UPDATE_APPEAL_PANEL[START],
  UPDATE_APPEAL_PANEL[SUCCESS],
  UPDATE_APPEAL_PANEL[ERROR],
);

export const DELETE_APPEAL_PANEL = createRequestTypes(
  `${namespace}/DELETE_APPEAL_PANEL`,
);
export const deleteAppealPanel = makeApiActionCreatorV3(
  api.deleteAppealPanel,
  DELETE_APPEAL_PANEL[START],
  DELETE_APPEAL_PANEL[SUCCESS],
  DELETE_APPEAL_PANEL[ERROR],
);

export const FETCH_APPEAL_PANEL_BOARD_MEMBER = createRequestTypes(
  `${namespace}/FETCH_APPEAL_PANEL_BOARD_MEMBER`,
);
export const fetchAppealPanelBoardMember = makeApiActionCreatorV3(
  api.fetchAppealPanelBoardMember,
  FETCH_APPEAL_PANEL_BOARD_MEMBER[START],
  FETCH_APPEAL_PANEL_BOARD_MEMBER[SUCCESS],
  FETCH_APPEAL_PANEL_BOARD_MEMBER[ERROR],
);

export const INSERT_APPEAL_PANEL_BOARD_MEMBER = createRequestTypes(
  `${namespace}/INSERT_APPEAL_PANEL_BOARD_MEMBER`,
);
export const insertAppealPanelBoardMember = makeApiActionCreatorV3(
  api.insertAppealPanelBoardMember,
  INSERT_APPEAL_PANEL_BOARD_MEMBER[START],
  INSERT_APPEAL_PANEL_BOARD_MEMBER[SUCCESS],
  INSERT_APPEAL_PANEL_BOARD_MEMBER[ERROR],
);

export const UPDATE_APPEAL_PANEL_BOARD_MEMBER = createRequestTypes(
  `${namespace}/UPDATE_APPEAL_PANEL_BOARD_MEMBER`,
);
export const updateAppealPanelBoardMember = makeApiActionCreatorV3(
  api.updateAppealPanelBoardMember,
  UPDATE_APPEAL_PANEL_BOARD_MEMBER[START],
  UPDATE_APPEAL_PANEL_BOARD_MEMBER[SUCCESS],
  UPDATE_APPEAL_PANEL_BOARD_MEMBER[ERROR],
);

export const DELETE_APPEAL_PANEL_BOARD_MEMBER = createRequestTypes(
  `${namespace}/DELETE_APPEAL_PANEL_BOARD_MEMBER`,
);
export const deleteAppealPanelBoardMember = makeApiActionCreatorV3(
  api.deleteAppealPanelBoardMember,
  DELETE_APPEAL_PANEL_BOARD_MEMBER[START],
  DELETE_APPEAL_PANEL_BOARD_MEMBER[SUCCESS],
  DELETE_APPEAL_PANEL_BOARD_MEMBER[ERROR],
);

export const FETCH_APPEAL_STAFF_ROLES = createRequestTypes(
  `${namespace}/FETCH_APPEAL_STAFF_ROLES`,
);
export const fetchAppealStaffRoles = makeApiActionCreatorV3(
  api.fetchAppealStaffRoles,
  FETCH_APPEAL_STAFF_ROLES[START],
  FETCH_APPEAL_STAFF_ROLES[SUCCESS],
  FETCH_APPEAL_STAFF_ROLES[ERROR],
);

export const FETCH_APPEAL_PANEL_CAD_STAFFS = createRequestTypes(
  `${namespace}/FETCH_APPEAL_PANEL_CAD_STAFFS`,
);
export const fetchAppealPanelCadStaffs = makeApiActionCreatorV3(
  api.fetchAppealPanelCadStaffs,
  FETCH_APPEAL_PANEL_CAD_STAFFS[START],
  FETCH_APPEAL_PANEL_CAD_STAFFS[SUCCESS],
  FETCH_APPEAL_PANEL_CAD_STAFFS[ERROR],
);

export const FETCH_APPEAL_PANEL_CAD_STAFF = createRequestTypes(
  `${namespace}/FETCH_APPEAL_PANEL_CAD_STAFF`,
);
export const fetchAppealPanelCadStaff = makeApiActionCreatorV3(
  api.fetchAppealPanelCadStaff,
  FETCH_APPEAL_PANEL_CAD_STAFF[START],
  FETCH_APPEAL_PANEL_CAD_STAFF[SUCCESS],
  FETCH_APPEAL_PANEL_CAD_STAFF[ERROR],
);

export const INSERT_APPEAL_PANEL_CAD_STAFF = createRequestTypes(
  `${namespace}/INSERT_APPEAL_PANEL_CAD_STAFF`,
);
export const insertAppealPanelCadStaff = makeApiActionCreatorV3(
  api.insertAppealPanelCadStaff,
  INSERT_APPEAL_PANEL_CAD_STAFF[START],
  INSERT_APPEAL_PANEL_CAD_STAFF[SUCCESS],
  INSERT_APPEAL_PANEL_CAD_STAFF[ERROR],
);

export const UPDATE_APPEAL_PANEL_CAD_STAFF = createRequestTypes(
  `${namespace}/UPDATE_APPEAL_PANEL_CAD_STAFF`,
);
export const updateAppealPanelCadStaff = makeApiActionCreatorV3(
  api.updateAppealPanelCadStaff,
  UPDATE_APPEAL_PANEL_CAD_STAFF[START],
  UPDATE_APPEAL_PANEL_CAD_STAFF[SUCCESS],
  UPDATE_APPEAL_PANEL_CAD_STAFF[ERROR],
);

export const DELETE_APPEAL_PANEL_CAD_STAFF = createRequestTypes(
  `${namespace}/DELETE_APPEAL_PANEL_CAD_STAFF`,
);
export const deleteAppealPanelCadStaff = makeApiActionCreatorV3(
  api.deleteAppealPanelCadStaff,
  DELETE_APPEAL_PANEL_CAD_STAFF[START],
  DELETE_APPEAL_PANEL_CAD_STAFF[SUCCESS],
  DELETE_APPEAL_PANEL_CAD_STAFF[ERROR],
);

export const FETCH_APPEAL_DECISION_AUTHORITY = createRequestTypes(
  `${namespace}/FETCH_APPEAL_DECISION_AUTHORITY`,
);
export const fetchAppealDecisionAuthority = makeApiActionCreatorV3(
  api.fetchAppealDecisionAuthority,
  FETCH_APPEAL_DECISION_AUTHORITY[START],
  FETCH_APPEAL_DECISION_AUTHORITY[SUCCESS],
  FETCH_APPEAL_DECISION_AUTHORITY[ERROR],
);

export const FETCH_APPEAL_DECISION_CODE = createRequestTypes(
  `${namespace}/FETCH_APPEAL_DECISION_CODE`,
);
export const fetchAppealDecisionCode = makeApiActionCreatorV3(
  api.fetchAppealDecisionCode,
  FETCH_APPEAL_DECISION_CODE[START],
  FETCH_APPEAL_DECISION_CODE[SUCCESS],
  FETCH_APPEAL_DECISION_CODE[ERROR],
);

export const FETCH_APPEAL_DECISION_REASON = createRequestTypes(
  `${namespace}/FETCH_APPEAL_DECISION_REASON`,
);
export const fetchAppealDecisionReason = makeApiActionCreatorV3(
  api.fetchAppealDecisionReason,
  FETCH_APPEAL_DECISION_REASON[START],
  FETCH_APPEAL_DECISION_REASON[SUCCESS],
  FETCH_APPEAL_DECISION_REASON[ERROR],
);

export const FETCH_APPEAL_DECISION_STATUS = createRequestTypes(
  `${namespace}/FETCH_APPEAL_DECISION_STATUS`,
);
export const fetchAppealDecisionStatus = makeApiActionCreatorV3(
  api.fetchAppealDecisionStatus,
  FETCH_APPEAL_DECISION_STATUS[START],
  FETCH_APPEAL_DECISION_STATUS[SUCCESS],
  FETCH_APPEAL_DECISION_STATUS[ERROR],
);

export const FETCH_APPEAL_RECOMMENDATION_REASON = createRequestTypes(
  `${namespace}/FETCH_APPEAL_RECOMMENDATION_REASON`,
);
export const fetchAppealRecommendationReason = makeApiActionCreatorV3(
  api.fetchAppealRecommendationReason,
  FETCH_APPEAL_RECOMMENDATION_REASON[START],
  FETCH_APPEAL_RECOMMENDATION_REASON[SUCCESS],
  FETCH_APPEAL_RECOMMENDATION_REASON[ERROR],
);

export const APPEAL_SEARCH_PARAMS_FETCH = createRequestTypes(
  `${namespace}/APPEAL_SEARCH_PARAMS_FETCH`,
);

export const fetchAppealSearchParams = makeApiActionCreatorV3(
  api.fetchAppealSearchParams,
  APPEAL_SEARCH_PARAMS_FETCH[START],
  APPEAL_SEARCH_PARAMS_FETCH[SUCCESS],
  APPEAL_SEARCH_PARAMS_FETCH[ERROR],
);

export const APPEAL_SEARCH_PARAM_FETCH = createRequestTypes(
  `${namespace}/APPEAL_SEARCH_PARAM_FETCH`,
);

export const fetchAppealSearchParam = makeApiActionCreatorV3(
  api.fetchAppealSearchParam,
  APPEAL_SEARCH_PARAM_FETCH[START],
  APPEAL_SEARCH_PARAM_FETCH[SUCCESS],
  APPEAL_SEARCH_PARAM_FETCH[ERROR],
);

export const APPEAL_SEARCH_PARAM_INSERT = createRequestTypes(
  `${namespace}/APPEAL_SEARCH_PARAM_INSERT`,
);

export const insertAppealSearchParam = makeApiActionCreatorV3(
  api.insertAppealSearchParam,
  APPEAL_SEARCH_PARAM_INSERT[START],
  APPEAL_SEARCH_PARAM_INSERT[SUCCESS],
  APPEAL_SEARCH_PARAM_INSERT[ERROR],
);

export const APPEAL_SEARCH_PARAM_UPDATE = createRequestTypes(
  `${namespace}/APPEAL_SEARCH_PARAM_UPDATE`,
);

export const updateAppealSearchParam = makeApiActionCreatorV3(
  api.updateAppealSearchParam,
  APPEAL_SEARCH_PARAM_UPDATE[START],
  APPEAL_SEARCH_PARAM_UPDATE[SUCCESS],
  APPEAL_SEARCH_PARAM_UPDATE[ERROR],
);

export const APPEAL_SEARCH_PARAM_DUPLICATE = createRequestTypes(
  `${namespace}/APPEAL_SEARCH_PARAM_DUPLICATE`,
);

export const duplicateAppealSearchParam = makeApiActionCreatorV3(
  api.duplicateAppealSearchParam,
  APPEAL_SEARCH_PARAM_DUPLICATE[START],
  APPEAL_SEARCH_PARAM_DUPLICATE[SUCCESS],
  APPEAL_SEARCH_PARAM_DUPLICATE[ERROR],
);

export const APPEAL_SEARCH_PARAM_DELETE = createRequestTypes(
  `${namespace}/APPEAL_SEARCH_PARAM_DELETE`,
);

export const deleteAppealSearchParam = makeApiActionCreatorV3(
  api.deleteAppealSearchParam,
  APPEAL_SEARCH_PARAM_DELETE[START],
  APPEAL_SEARCH_PARAM_DELETE[SUCCESS],
  APPEAL_SEARCH_PARAM_DELETE[ERROR],
);

export const APPEAL_SEARCH_PARAM_RESET = `${namespace}/APPEAL_SEARCH_PARAM_RESET`;

export const resetAppealSearchParam = () => ({
  type: APPEAL_SEARCH_PARAM_RESET,
});

export const APPEAL_SEARCH_RESET = `${namespace}/APPEAL_SEARCH_RESET`;

export const resetAppealSearch = () => ({
  type: APPEAL_SEARCH_RESET,
});

export const APPEAL_SEARCH_PARAM_SET = `${namespace}/APPEAL_SEARCH_PARAM_SET`;

export const setAppealSearchParam = (searchParamID) => ({
  type: APPEAL_SEARCH_PARAM_SET,
  searchParamID,
});

export const SET_LAST_SEARCH = `${namespace}/SET_LAST_SEARCH`;

export const setLastSearch = (data) => ({
  type: SET_LAST_SEARCH,
  data,
});

export const FETCH_CONFIGURATION_BY_APPEAL = createRequestTypes(
  `${namespace}/FETCH_CONFIGURATION_BY_APPEAL`,
);
export const fetchConfigurationByAppeal = makeApiActionCreatorV3(
  api.fetchConfigurationByAppeal,
  FETCH_CONFIGURATION_BY_APPEAL[START],
  FETCH_CONFIGURATION_BY_APPEAL[SUCCESS],
  FETCH_CONFIGURATION_BY_APPEAL[ERROR],
);

export const FETCH_APPEAL_RECOMMENDATIONS = createRequestTypes(
  `${namespace}/FETCH_APPEAL_RECOMMENDATIONS`,
);
export const fetchAppealRecommendations = makeApiActionCreatorV3(
  api.fetchAppealRecommendations,
  FETCH_APPEAL_RECOMMENDATIONS[START],
  FETCH_APPEAL_RECOMMENDATIONS[SUCCESS],
  FETCH_APPEAL_RECOMMENDATIONS[ERROR],
);

export const FETCH_RECOMMENDATION_VALUES = createRequestTypes(
  `${namespace}/FETCH_RECOMMENDATION_VALUES`,
);
export const fetchRecommendationValues = makeApiActionCreatorV3(
  api.fetchRecommendationValues,
  FETCH_RECOMMENDATION_VALUES[START],
  FETCH_RECOMMENDATION_VALUES[SUCCESS],
  FETCH_RECOMMENDATION_VALUES[ERROR],
);

export const INSERT_RECOMMENDATION = createRequestTypes(
  `${namespace}/INSERT_RECOMMENDATION`,
);
export const insertRecommendation = makeApiActionCreatorV3(
  api.insertRecommendation,
  INSERT_RECOMMENDATION[START],
  INSERT_RECOMMENDATION[SUCCESS],
  INSERT_RECOMMENDATION[ERROR],
);

export const FETCH_RECOMMENDATION = createRequestTypes(
  `${namespace}/FETCH_RECOMMENDATION`,
);
export const fetchRecommendation = makeApiActionCreatorV3(
  api.fetchRecommendation,
  FETCH_RECOMMENDATION[START],
  FETCH_RECOMMENDATION[SUCCESS],
  FETCH_RECOMMENDATION[ERROR],
);

export const ACCEPT_RECOMMENDATION = createRequestTypes(
  `${namespace}/ACCEPT_RECOMMENDATION`,
);
export const acceptRecommendation = makeApiActionCreatorV3(
  api.acceptRecommendation,
  ACCEPT_RECOMMENDATION[START],
  ACCEPT_RECOMMENDATION[SUCCESS],
  ACCEPT_RECOMMENDATION[ERROR],
);

export const CANCEL_RECOMMENDATION = createRequestTypes(
  `${namespace}/CANCEL_RECOMMENDATION`,
);
export const cancelRecommendation = makeApiActionCreatorV3(
  api.cancelRecommendation,
  CANCEL_RECOMMENDATION[START],
  CANCEL_RECOMMENDATION[SUCCESS],
  CANCEL_RECOMMENDATION[ERROR],
);

export const INSERT_RECOMMENDATION_FILE = createRequestTypes(
  `${namespace}/INSERT_RECOMMENDATION_FILE`,
);
export const insertRecommendationFile = makeApiActionCreatorV3(
  api.insertRecommendationFile,
  INSERT_RECOMMENDATION_FILE[START],
  INSERT_RECOMMENDATION_FILE[SUCCESS],
  INSERT_RECOMMENDATION_FILE[ERROR],
);

export const UPDATE_RECOMMENDATION_FILE = createRequestTypes(
  `${namespace}/UPDATE_RECOMMENDATION_FILE`,
);
export const updateRecommendationFile = makeApiActionCreatorV3(
  api.updateRecommendationFile,
  UPDATE_RECOMMENDATION_FILE[START],
  UPDATE_RECOMMENDATION_FILE[SUCCESS],
  UPDATE_RECOMMENDATION_FILE[ERROR],
);

export const DOWNLOAD_RECOMMENDATION_FILE = createRequestTypes(
  `${namespace}/DOWNLOAD_RECOMMENDATION_FILE`,
);
export const downloadRecommendationFile = makeApiActionCreatorV3(
  api.downloadRecommendationFile,
  DOWNLOAD_RECOMMENDATION_FILE[START],
  DOWNLOAD_RECOMMENDATION_FILE[SUCCESS],
  DOWNLOAD_RECOMMENDATION_FILE[ERROR],
);

export const DELETE_RECOMMENDATION_FILE = createRequestTypes(
  `${namespace}/DELETE_RECOMMENDATION_FILE`,
);
export const deleteRecommendationFile = makeApiActionCreatorV3(
  api.deleteRecommendationFile,
  DELETE_RECOMMENDATION_FILE[START],
  DELETE_RECOMMENDATION_FILE[SUCCESS],
  DELETE_RECOMMENDATION_FILE[ERROR],
);

export const SET_PRINT_CARD_DATA = `${namespace}/SET_PRINT_CARD_DATA`;

export function setPrintCardData(data) {
  return async (dispatch) => {
    dispatch({ type: SET_PRINT_CARD_DATA, windowData: data });
  };
}

export const FETCH_STATUS_CODES = createRequestTypes(
  `${namespace}/FETCH_STATUS_CODES`,
);
export const fetchStatusCodes = makeApiActionCreatorV3(
  api.fetchStatusCodes,
  FETCH_STATUS_CODES[START],
  FETCH_STATUS_CODES[SUCCESS],
  FETCH_STATUS_CODES[ERROR],
);

export const DELETE_STATUS_CODE = createRequestTypes(
  `${namespace}/DELETE_STATUS_CODE`,
);
export const deleteStatusCode = makeApiActionCreatorV3(
  api.deleteStatusCode,
  DELETE_STATUS_CODE[START],
  DELETE_STATUS_CODE[SUCCESS],
  DELETE_STATUS_CODE[ERROR],
);

export const APPEAL_STATUS_CONFIG_STATE = createRequestTypes(
  `${namespace}/APPEAL_STATUS_CONFIG_STATE`,
);
export const appealStatusConfigState = makeApiActionCreatorV3(
  api.appealStatusConfigState,
  APPEAL_STATUS_CONFIG_STATE[START],
  APPEAL_STATUS_CONFIG_STATE[SUCCESS],
  APPEAL_STATUS_CONFIG_STATE[ERROR],
);

export const APPEAL_MODULE_REPORTS = createRequestTypes(
  `${namespace}/APPEAL_MODULE_REPORTS`,
);
export const appealModuleReports = makeApiActionCreatorV3(
  api.appealModuleReports,
  APPEAL_MODULE_REPORTS[START],
  APPEAL_MODULE_REPORTS[SUCCESS],
  APPEAL_MODULE_REPORTS[ERROR],
);

export const FETCH_APPEAL_STATUS = createRequestTypes(
  `${namespace}/FETCH_APPEAL_STATUS`,
);
export const fetchAppealStatus = makeApiActionCreatorV3(
  api.fetchAppealStatus,
  FETCH_APPEAL_STATUS[START],
  FETCH_APPEAL_STATUS[SUCCESS],
  FETCH_APPEAL_STATUS[ERROR],
);

export const INSERT_APPEAL_STATUS_CONFIG = createRequestTypes(
  `${namespace}/INSERT_APPEAL_STATUS_CONFIG`,
);
export const insertAppealStatusConfig = makeApiActionCreatorV3(
  api.insertAppealStatusConfig,
  INSERT_APPEAL_STATUS_CONFIG[START],
  INSERT_APPEAL_STATUS_CONFIG[SUCCESS],
  INSERT_APPEAL_STATUS_CONFIG[ERROR],
);

export const UPDATE_APPEAL_STATUS_CONFIG = createRequestTypes(
  `${namespace}/UPDATE_APPEAL_STATUS_CONFIG`,
);
export const updateAppealStatusConfig = makeApiActionCreatorV3(
  api.updateAppealStatusConfig,
  UPDATE_APPEAL_STATUS_CONFIG[START],
  UPDATE_APPEAL_STATUS_CONFIG[SUCCESS],
  UPDATE_APPEAL_STATUS_CONFIG[ERROR],
);

export const DOWNLOAD_PORTAL_ACTIVITY_FILE = createRequestTypes(
  `${namespace}/DOWNLOAD_PORTAL_ACTIVITY_FILE`,
);
export const downloadPortalActivityFile = makeApiActionCreatorV3(
  api.downloadPortalActivityFile,
  DOWNLOAD_PORTAL_ACTIVITY_FILE[START],
  DOWNLOAD_PORTAL_ACTIVITY_FILE[SUCCESS],
  DOWNLOAD_PORTAL_ACTIVITY_FILE[ERROR],
);

export const GENERATE_INDIVIDUAL_LETTER = createRequestTypes(
  `${namespace}/GENERATE_INDIVIDUAL_LETTER`,
);
export const generateIndividualLetter = makeApiActionCreatorV3(
  api.generateIndividualLetter,
  GENERATE_INDIVIDUAL_LETTER[START],
  GENERATE_INDIVIDUAL_LETTER[SUCCESS],
  GENERATE_INDIVIDUAL_LETTER[ERROR],
);

export const MASS_GENERATE_FINAL_LETTERS_VALIDATE_APPEAL_LIST =
  createRequestTypes(
    `${namespace}/MASS_GENERATE_FINAL_LETTERS_VALIDATE_APPEAL_LIST`,
  );
export const massGenerateFinalLettersValidateAppealList =
  makeApiActionCreatorV3(
    api.massGenerateFinalLettersValidateAppealList,
    MASS_GENERATE_FINAL_LETTERS_VALIDATE_APPEAL_LIST[START],
    MASS_GENERATE_FINAL_LETTERS_VALIDATE_APPEAL_LIST[SUCCESS],
    MASS_GENERATE_FINAL_LETTERS_VALIDATE_APPEAL_LIST[ERROR],
  );

export const MASS_FINALIZE_VALIDATE_APPEAL_LIST = createRequestTypes(
  `${namespace}/MASS_FINALIZE_VALIDATE_APPEAL_LIST`,
);
export const massFinalizeValidateAppealList = makeApiActionCreatorV3(
  api.massFinalizeValidateAppealList,
  MASS_FINALIZE_VALIDATE_APPEAL_LIST[START],
  MASS_FINALIZE_VALIDATE_APPEAL_LIST[SUCCESS],
  MASS_FINALIZE_VALIDATE_APPEAL_LIST[ERROR],
);

export const MASS_REOPEN_VALIDATE_APPEAL_LIST = createRequestTypes(
  `${namespace}/MASS_REOPEN_VALIDATE_APPEAL_LIST`,
);
export const massReopenValidateAppealList = makeApiActionCreatorV3(
  api.massReopenValidateAppealList,
  MASS_REOPEN_VALIDATE_APPEAL_LIST[START],
  MASS_REOPEN_VALIDATE_APPEAL_LIST[SUCCESS],
  MASS_REOPEN_VALIDATE_APPEAL_LIST[ERROR],
);

export const MASS_FINALIZE_VALIDATE_APPEAL_LIST_FOR_ROLLCORRECTION =
  createRequestTypes(
    `${namespace}/MASS_FINALIZE_VALIDATE_APPEAL_LIST_FOR_ROLLCORRECTION`,
  );
export const massFinalizeValidateAppealListForRollCorrection =
  makeApiActionCreatorV3(
    api.massFinalizeValidateAppealListForRollCorrection,
    MASS_FINALIZE_VALIDATE_APPEAL_LIST_FOR_ROLLCORRECTION[START],
    MASS_FINALIZE_VALIDATE_APPEAL_LIST_FOR_ROLLCORRECTION[SUCCESS],
    MASS_FINALIZE_VALIDATE_APPEAL_LIST_FOR_ROLLCORRECTION[ERROR],
  );

export const MASS_FINALIZE_APPEAL_LIST = createRequestTypes(
  `${namespace}/MASS_FINALIZE_APPEAL_LIST`,
);
export const massFinalizeAppealList = makeApiActionCreatorV3(
  api.massFinalizeAppealList,
  MASS_FINALIZE_APPEAL_LIST[START],
  MASS_FINALIZE_APPEAL_LIST[SUCCESS],
  MASS_FINALIZE_APPEAL_LIST[ERROR],
);

export const MASS_FINALIZE_APPEAL_LIST_STATUS = createRequestTypes(
  `${namespace}/MASS_FINALIZE_APPEAL_LIST_STATUS`,
);
export const massFinalizeAppealListStatus = makeApiActionCreatorV3(
  api.massFinalizeAppealListStatus,
  MASS_FINALIZE_APPEAL_LIST_STATUS[START],
  MASS_FINALIZE_APPEAL_LIST_STATUS[SUCCESS],
  MASS_FINALIZE_APPEAL_LIST_STATUS[ERROR],
);

export const MASS_GENERATE_FINAL_LETTERS = createRequestTypes(
  `${namespace}/MASS_GENERATE_FINAL_LETTERS`,
);
export const massGenerateFinalLetters = makeApiActionCreatorV3(
  api.massGenerateFinalLetters,
  MASS_GENERATE_FINAL_LETTERS[START],
  MASS_GENERATE_FINAL_LETTERS[SUCCESS],
  MASS_GENERATE_FINAL_LETTERS[ERROR],
);

export const MASS_CLEAR_FORMAL_HEARING_DATE = createRequestTypes(
  `${namespace}/MASS_CLEAR_FORMAL_HEARING_DATE`,
);
export const massClearFormalHearingDate = makeApiActionCreatorV3(
  api.massClearFormalHearingDate,
  MASS_CLEAR_FORMAL_HEARING_DATE[START],
  MASS_CLEAR_FORMAL_HEARING_DATE[SUCCESS],
  MASS_CLEAR_FORMAL_HEARING_DATE[ERROR],
);

export const MASS_CLEAR_FORMAL_ARRIVAL_TIME = createRequestTypes(
  `${namespace}/MASS_CLEAR_FORMAL_ARRIVAL_TIME`,
);
export const massClearFormalArrivalTime = makeApiActionCreatorV3(
  api.massClearFormalArrivalTime,
  MASS_CLEAR_FORMAL_ARRIVAL_TIME[START],
  MASS_CLEAR_FORMAL_ARRIVAL_TIME[SUCCESS],
  MASS_CLEAR_FORMAL_ARRIVAL_TIME[ERROR],
);

export const MASS_APPEAL_PROTESTER_UPDATE = createRequestTypes(
  `${namespace}/MASS_APPEAL_PROTESTER_UPDATE`,
);
export const massAppealProtesterUpdate = makeApiActionCreatorV3(
  api.massAppealProtesterUpdate,
  MASS_APPEAL_PROTESTER_UPDATE[START],
  MASS_APPEAL_PROTESTER_UPDATE[SUCCESS],
  MASS_APPEAL_PROTESTER_UPDATE[ERROR],
);

export const MASS_CLEAR_INFORMAL_HEARING_DATE = createRequestTypes(
  `${namespace}/MASS_CLEAR_INFORMAL_HEARING_DATE`,
);
export const massClearInformalHearingDate = makeApiActionCreatorV3(
  api.massClearInformalHearingDate,
  MASS_CLEAR_INFORMAL_HEARING_DATE[START],
  MASS_CLEAR_INFORMAL_HEARING_DATE[SUCCESS],
  MASS_CLEAR_INFORMAL_HEARING_DATE[ERROR],
);

export const MASS_CLEAR_INFORMAL_ARRIVAL_TIME = createRequestTypes(
  `${namespace}/MASS_CLEAR_INFORMAL_ARRIVAL_TIME`,
);
export const massClearInformalArrivalTime = makeApiActionCreatorV3(
  api.massClearInformalArrivalTime,
  MASS_CLEAR_INFORMAL_ARRIVAL_TIME[START],
  MASS_CLEAR_INFORMAL_ARRIVAL_TIME[SUCCESS],
  MASS_CLEAR_INFORMAL_ARRIVAL_TIME[ERROR],
);

export const MASS_REOPEN = createRequestTypes(`${namespace}/MASS_REOPEN`);
export const massReopen = makeApiActionCreatorV3(
  api.massReopen,
  MASS_REOPEN[START],
  MASS_REOPEN[SUCCESS],
  MASS_REOPEN[ERROR],
);

export const CLEAR_FORMAL_HEARING_DATE = createRequestTypes(
  `${namespace}/CLEAR_FORMAL_HEARING_DATE`,
);
export const clearFormalHearingDate = makeApiActionCreatorV3(
  api.clearFormalHearingDate,
  CLEAR_FORMAL_HEARING_DATE[START],
  CLEAR_FORMAL_HEARING_DATE[SUCCESS],
  CLEAR_FORMAL_HEARING_DATE[ERROR],
);

export const CLEAR_FORMAL_ARRIVAL_TIME = createRequestTypes(
  `${namespace}/CLEAR_FORMAL_ARRIVAL_TIME`,
);
export const clearFormalArrivalTime = makeApiActionCreatorV3(
  api.clearFormalArrivalTime,
  CLEAR_FORMAL_ARRIVAL_TIME[START],
  CLEAR_FORMAL_ARRIVAL_TIME[SUCCESS],
  CLEAR_FORMAL_ARRIVAL_TIME[ERROR],
);

export const CLEAR_INFORMAL_HEARING_DATE = createRequestTypes(
  `${namespace}/CLEAR_INFORMAL_HEARING_DATE`,
);
export const clearInformalHearingDate = makeApiActionCreatorV3(
  api.clearInformalHearingDate,
  CLEAR_INFORMAL_HEARING_DATE[START],
  CLEAR_INFORMAL_HEARING_DATE[SUCCESS],
  CLEAR_INFORMAL_HEARING_DATE[ERROR],
);

export const CLEAR_INFORMAL_ARRIVAL_TIME = createRequestTypes(
  `${namespace}/CLEAR_INFORMAL_ARRIVAL_TIME`,
);
export const clearInformalArrivalTime = makeApiActionCreatorV3(
  api.clearInformalArrivalTime,
  CLEAR_INFORMAL_ARRIVAL_TIME[START],
  CLEAR_INFORMAL_ARRIVAL_TIME[SUCCESS],
  CLEAR_INFORMAL_ARRIVAL_TIME[ERROR],
);

export const MASS_GENERATE_FINAL_LETTERS_STATUS = createRequestTypes(
  `${namespace}/MASS_GENERATE_FINAL_LETTERS_STATUS`,
);
export const massGenerateFinalLettersStatus = makeApiActionCreatorV3(
  api.massGenerateFinalLettersStatus,
  MASS_GENERATE_FINAL_LETTERS_STATUS[START],
  MASS_GENERATE_FINAL_LETTERS_STATUS[SUCCESS],
  MASS_GENERATE_FINAL_LETTERS_STATUS[ERROR],
);

export const MASS_GENERATE_FINAL_LETTERS_DOCUMENTS = createRequestTypes(
  `${namespace}/MASS_GENERATE_FINAL_LETTERS_DOCUMENTS`,
);
export const massGenerateFinalLettersDocuments = makeApiActionCreatorV3(
  api.massGenerateFinalLettersDocuments,
  MASS_GENERATE_FINAL_LETTERS_DOCUMENTS[START],
  MASS_GENERATE_FINAL_LETTERS_DOCUMENTS[SUCCESS],
  MASS_GENERATE_FINAL_LETTERS_DOCUMENTS[ERROR],
);

export const FETCH_FINAL_LETTER_HISTORY = createRequestTypes(
  `${namespace}/FETCH_FINAL_LETTER_HISTORY`,
);
export const fetchFinalLetterHistory = makeApiActionCreatorV3(
  api.fetchFinalLetterHistory,
  FETCH_FINAL_LETTER_HISTORY[START],
  FETCH_FINAL_LETTER_HISTORY[SUCCESS],
  FETCH_FINAL_LETTER_HISTORY[ERROR],
);

export const FETCH_MASS_FINALIZE_HISTORY = createRequestTypes(
  `${namespace}/FETCH_MASS_FINALIZE_HISTORY`,
);
export const fetchMassFinalizeHistory = makeApiActionCreatorV3(
  api.fetchMassFinalizeHistory,
  FETCH_MASS_FINALIZE_HISTORY[START],
  FETCH_MASS_FINALIZE_HISTORY[SUCCESS],
  FETCH_MASS_FINALIZE_HISTORY[ERROR],
);

export const FETCH_MASS_APPEAL_LETTER_HISTORY = createRequestTypes(
  `${namespace}/FETCH_MASS_APPEAL_LETTER_HISTORY`,
);
export const fetchMassAppealLetterHistory = makeApiActionCreatorV3(
  api.fetchMassAppealLetterHistory,
  FETCH_MASS_APPEAL_LETTER_HISTORY[START],
  FETCH_MASS_APPEAL_LETTER_HISTORY[SUCCESS],
  FETCH_MASS_APPEAL_LETTER_HISTORY[ERROR],
);

export const FETCH_MASS_PROCESS_ENTRIES = createRequestTypes(
  `${namespace}/FETCH_MASS_PROCESS_ENTRIES`,
);
export const fetchMassProcessEntries = makeApiActionCreatorV3(
  api.fetchMassProcessEntries,
  FETCH_MASS_PROCESS_ENTRIES[START],
  FETCH_MASS_PROCESS_ENTRIES[SUCCESS],
  FETCH_MASS_PROCESS_ENTRIES[ERROR],
);

export const CREATE_MASS_PROCESS_ENTRY = createRequestTypes(
  `${namespace}/CREATE_MASS_PROCESS_ENTRY`,
);
export const createMassProcessEntry = makeApiActionCreatorV3(
  api.createMassProcessEntry,
  CREATE_MASS_PROCESS_ENTRY[START],
  CREATE_MASS_PROCESS_ENTRY[SUCCESS],
  CREATE_MASS_PROCESS_ENTRY[ERROR],
);

export const FETCH_MASS_PROCESS_HISTORY = createRequestTypes(
  `${namespace}/FETCH_MASS_PROCESS_HISTORY`,
);
export const fetchMassProcessHistory = makeApiActionCreatorV3(
  api.fetchMassProcessHistory,
  FETCH_MASS_PROCESS_HISTORY[START],
  FETCH_MASS_PROCESS_HISTORY[SUCCESS],
  FETCH_MASS_PROCESS_HISTORY[ERROR],
);

export const FETCH_MASS_ATTACH_HISTORY = createRequestTypes(
  `${namespace}/FETCH_MASS_ATTACH_HISTORY`,
);
export const fetchMassAttachHistory = makeApiActionCreatorV3(
  api.fetchMassAttachHistory,
  FETCH_MASS_ATTACH_HISTORY[START],
  FETCH_MASS_ATTACH_HISTORY[SUCCESS],
  FETCH_MASS_ATTACH_HISTORY[ERROR],
);

export const FETCH_EVIDENCE_UPLOAD_HISTORY = createRequestTypes(
  `${namespace}/FETCH_EVIDENCE_UPLOAD_HISTORY`,
);
export const fetchEvidenceUploadHistory = makeApiActionCreatorV3(
  api.fetchEvidenceUploadHistory,
  FETCH_EVIDENCE_UPLOAD_HISTORY[START],
  FETCH_EVIDENCE_UPLOAD_HISTORY[SUCCESS],
  FETCH_EVIDENCE_UPLOAD_HISTORY[ERROR],
);

export const FETCH_EVIDENCE_IMPORT_PROPERTIES = createRequestTypes(
  `${namespace}/FETCH_EVIDENCE_IMPORT_PROPERTIES`,
);
export const fetchEvidenceImportProperties = makeApiActionCreatorV3(
  api.fetchEvidenceImportProperties,
  FETCH_EVIDENCE_IMPORT_PROPERTIES[START],
  FETCH_EVIDENCE_IMPORT_PROPERTIES[SUCCESS],
  FETCH_EVIDENCE_IMPORT_PROPERTIES[ERROR],
);

export const DOWNLOAD_EVIDENCE_IMPORT_FILE = createRequestTypes(
  `${namespace}/DOWNLOAD_EVIDENCE_IMPORT_FILE`,
);
export const downloadEvidenceImportFile = makeApiActionCreatorV3(
  api.downloadEvidenceImportFile,
  DOWNLOAD_EVIDENCE_IMPORT_FILE[START],
  DOWNLOAD_EVIDENCE_IMPORT_FILE[SUCCESS],
  DOWNLOAD_EVIDENCE_IMPORT_FILE[ERROR],
);

export const DOWNLOAD_EVIDENCE_IMPORT_PROPERTY_FILE = createRequestTypes(
  `${namespace}/DOWNLOAD_EVIDENCE_IMPORT_PROPERTY_FILE`,
);
export const downloadEvidenceImportPropertyFile = makeApiActionCreatorV3(
  api.downloadEvidenceImportPropertyFile,
  DOWNLOAD_EVIDENCE_IMPORT_PROPERTY_FILE[START],
  DOWNLOAD_EVIDENCE_IMPORT_PROPERTY_FILE[SUCCESS],
  DOWNLOAD_EVIDENCE_IMPORT_PROPERTY_FILE[ERROR],
);

export const FETCH_MASS_DOWNLOAD_HISTORY = createRequestTypes(
  `${namespace}/FETCH_MASS_DOWNLOAD_HISTORY`,
);
export const fetchMassDownloadHistory = makeApiActionCreatorV3(
  api.fetchMassDownloadHistory,
  FETCH_MASS_DOWNLOAD_HISTORY[START],
  FETCH_MASS_DOWNLOAD_HISTORY[SUCCESS],
  FETCH_MASS_DOWNLOAD_HISTORY[ERROR],
);

export const FETCH_MASS_DOWNLOAD_PROPERTY_HISTORY = createRequestTypes(
  `${namespace}/FETCH_MASS_DOWNLOAD_PROPERTY_HISTORY`,
);
export const fetchMassDownloadPropertyHistory = makeApiActionCreatorV3(
  api.fetchMassDownloadPropertyHistory,
  FETCH_MASS_DOWNLOAD_PROPERTY_HISTORY[START],
  FETCH_MASS_DOWNLOAD_PROPERTY_HISTORY[SUCCESS],
  FETCH_MASS_DOWNLOAD_PROPERTY_HISTORY[ERROR],
);
export const FETCH_MASS_AOA_HISTORY = createRequestTypes(
  `${namespace}/FETCH_MASS_AOA_HISTORY`,
);
export const fetchMassAoaHistory = makeApiActionCreatorV3(
  api.fetchMassAoaHistory,
  FETCH_MASS_AOA_HISTORY[START],
  FETCH_MASS_AOA_HISTORY[SUCCESS],
  FETCH_MASS_AOA_HISTORY[ERROR],
);

export const FETCH_MASS_AOA_HISTORY_PROPERTIES = createRequestTypes(
  `${namespace}/FETCH_MASS_AOA_HISTORY_PROPERTIES`,
);
export const fetchMassAoaHistoryProperties = makeApiActionCreatorV3(
  api.fetchMassAoaHistoryProperties,
  FETCH_MASS_AOA_HISTORY_PROPERTIES[START],
  FETCH_MASS_AOA_HISTORY_PROPERTIES[SUCCESS],
  FETCH_MASS_AOA_HISTORY_PROPERTIES[ERROR],
);

export const FETCH_MASS_AOA_PROPERTY_LIST = createRequestTypes(
  `${namespace}/FETCH_MASS_AOA_PROPERTY_LIST`,
);
export const fetchMassAoaPropertyList = makeApiActionCreatorV3(
  api.fetchMassAoaPropertyList,
  FETCH_MASS_AOA_PROPERTY_LIST[START],
  FETCH_MASS_AOA_PROPERTY_LIST[SUCCESS],
  FETCH_MASS_AOA_PROPERTY_LIST[ERROR],
);

export const REOPEN_APPEAL = createRequestTypes(`${namespace}/REOPEN_APPEAL`);
export const reopenAppeal = makeApiActionCreatorV3(
  api.reopenAppeal,
  REOPEN_APPEAL[START],
  REOPEN_APPEAL[SUCCESS],
  REOPEN_APPEAL[ERROR],
);

export const GENERATE_FINAL_LETTER = createRequestTypes(
  `${namespace}/GENERATE_FINAL_LETTER`,
);
export const generateFinalLetter = makeApiActionCreatorV3(
  api.generateFinalLetter,
  GENERATE_FINAL_LETTER[START],
  GENERATE_FINAL_LETTER[SUCCESS],
  GENERATE_FINAL_LETTER[ERROR],
);

export const FETCH_AUTO_PACKET_STATUS = createRequestTypes(
  `${namespace}/FETCH_AUTO_PACKET_STATUS`,
);
export const fetchAutoPacketStatus = makeApiActionCreatorV3(
  api.fetchAutoPacketStatus,
  FETCH_AUTO_PACKET_STATUS[START],
  FETCH_AUTO_PACKET_STATUS[SUCCESS],
  FETCH_AUTO_PACKET_STATUS[ERROR],
);

export const VALIDATE_PID_LIST = createRequestTypes(
  'APPRAISAL/VALIDATE_PID_LIST',
);

export const validatePidList = makeApiActionCreatorV3(
  api.validatePidList,
  VALIDATE_PID_LIST[START],
  VALIDATE_PID_LIST[SUCCESS],
  VALIDATE_PID_LIST[ERROR],
);

export const CREATE_MASS_APPEAL_WITH_AGENT = createRequestTypes(
  'APPRAISAL/CREATE_MASS_APPEAL_WITH_AGENT',
);

export const createMassAppealWithAgent = makeApiActionCreatorV3(
  api.createMassAppealWithAgent,
  CREATE_MASS_APPEAL_WITH_AGENT[START],
  CREATE_MASS_APPEAL_WITH_AGENT[SUCCESS],
  CREATE_MASS_APPEAL_WITH_AGENT[ERROR],
);

export const CREATE_MASS_APPEAL_WITH_OWNER = createRequestTypes(
  'APPRAISAL/CREATE_MASS_APPEAL_WITH_OWNER',
);

export const createMassAppealWithOwner = makeApiActionCreatorV3(
  api.createMassAppealWithOwner,
  CREATE_MASS_APPEAL_WITH_OWNER[START],
  CREATE_MASS_APPEAL_WITH_OWNER[SUCCESS],
  CREATE_MASS_APPEAL_WITH_OWNER[ERROR],
);

export const REINITIALIZE_APPEAL_SUMMARY = createRequestTypes(
  `${namespace}/REINITIALIZE_APPEAL_SUMMARY`,
);
export const reinitializeAppealSummary = makeApiActionCreatorV3(
  api.reinitializeAppealSummary,
  REINITIALIZE_APPEAL_SUMMARY[START],
  REINITIALIZE_APPEAL_SUMMARY[SUCCESS],
  REINITIALIZE_APPEAL_SUMMARY[ERROR],
);

export const MASS_CREATE_RECOMMENDATION = createRequestTypes(
  `${namespace}/MASS_CREATE_RECOMMENDATION`,
);
export const massCreateRecommendation = makeApiActionCreatorV3(
  api.massCreateRecommendation,
  MASS_CREATE_RECOMMENDATION[START],
  MASS_CREATE_RECOMMENDATION[SUCCESS],
  MASS_CREATE_RECOMMENDATION[ERROR],
);

export const FETCH_MASS_CREATE_RECOMMENDATION_STATUS = createRequestTypes(
  `${namespace}/FETCH_MASS_CREATE_RECOMMENDATION_STATUS`,
);
export const fetchMassCreateRecommendationStatus = makeApiActionCreatorV3(
  api.fetchMassCreateRecommendationStatus,
  FETCH_MASS_CREATE_RECOMMENDATION_STATUS[START],
  FETCH_MASS_CREATE_RECOMMENDATION_STATUS[SUCCESS],
  FETCH_MASS_CREATE_RECOMMENDATION_STATUS[ERROR],
);

export const INSERT_APPEAL_ACTIVITY_FILE_LOG = createRequestTypes(
  `${namespace}/INSERT_APPEAL_ACTIVITY_FILE_LOG`,
);
export const insertAppealActivityFileLog = makeApiActionCreatorV3(
  api.insertAppealActivityFileLog,
  INSERT_APPEAL_ACTIVITY_FILE_LOG[START],
  INSERT_APPEAL_ACTIVITY_FILE_LOG[SUCCESS],
  INSERT_APPEAL_ACTIVITY_FILE_LOG[ERROR],
);

export const INSERT_MASS_ATTACH_LOG = createRequestTypes(
  `${namespace}/INSERT_MASS_ATTACH_LOG`,
);
export const insertMassAttachLog = makeApiActionCreatorV3(
  api.insertMassAttachLog,
  INSERT_MASS_ATTACH_LOG[START],
  INSERT_MASS_ATTACH_LOG[SUCCESS],
  INSERT_MASS_ATTACH_LOG[ERROR],
);

export const FETCH_MASS_ATTACH_LOG = createRequestTypes(
  `${namespace}/FETCH_MASS_ATTACH_LOG`,
);
export const fetchMassAttachLog = makeApiActionCreatorV3(
  api.fetchMassAttachLog,
  FETCH_MASS_ATTACH_LOG[START],
  FETCH_MASS_ATTACH_LOG[SUCCESS],
  FETCH_MASS_ATTACH_LOG[ERROR],
);

export const INSERT_APPEAL_ACTIVITY_FILE = createRequestTypes(
  `${namespace}/INSERT_APPEAL_ACTIVITY_FILE`,
);
export const insertAppealActivityFile = makeApiActionCreatorV3(
  api.insertAppealActivityFile,
  INSERT_APPEAL_ACTIVITY_FILE[START],
  INSERT_APPEAL_ACTIVITY_FILE[SUCCESS],
  INSERT_APPEAL_ACTIVITY_FILE[ERROR],
);

export const INSERT_MASS_ATTACH_LOG_FILE = createRequestTypes(
  `${namespace}/INSERT_MASS_ATTACH_LOG_FILE`,
);
export const insertMassAttachLogFile = makeApiActionCreatorV3(
  api.insertMassAttachLogFile,
  INSERT_MASS_ATTACH_LOG_FILE[START],
  INSERT_MASS_ATTACH_LOG_FILE[SUCCESS],
  INSERT_MASS_ATTACH_LOG_FILE[ERROR],
);

export const DELETE_APPEAL_ACTIVITY_FILE = createRequestTypes(
  `${namespace}/DELETE_APPEAL_ACTIVITY_FILE`,
);
export const deleteAppealActivityFile = makeApiActionCreatorV3(
  api.deleteAppealActivityFile,
  DELETE_APPEAL_ACTIVITY_FILE[START],
  DELETE_APPEAL_ACTIVITY_FILE[SUCCESS],
  DELETE_APPEAL_ACTIVITY_FILE[ERROR],
);

export const DELETE_MASS_ATTACH_LOG_FILE = createRequestTypes(
  `${namespace}/DELETE_MASS_ATTACH_LOG_FILE`,
);
export const deleteMassAttachLogFile = makeApiActionCreatorV3(
  api.deleteMassAttachLogFile,
  DELETE_MASS_ATTACH_LOG_FILE[START],
  DELETE_MASS_ATTACH_LOG_FILE[SUCCESS],
  DELETE_MASS_ATTACH_LOG_FILE[ERROR],
);

export const UPDATE_MASS_ATTACH_LOG = createRequestTypes(
  `${namespace}/UPDATE_MASS_ATTACH_LOG`,
);
export const updateMassAttachLog = makeApiActionCreatorV3(
  api.updateMassAttachLog,
  UPDATE_MASS_ATTACH_LOG[START],
  UPDATE_MASS_ATTACH_LOG[SUCCESS],
  UPDATE_MASS_ATTACH_LOG[ERROR],
);

export const RUN_MASS_ATTACH_LOG = createRequestTypes(
  `${namespace}/RUN_MASS_ATTACH_LOG`,
);
export const runMassAttachLog = makeApiActionCreatorV3(
  api.runMassAttachLog,
  RUN_MASS_ATTACH_LOG[START],
  RUN_MASS_ATTACH_LOG[SUCCESS],
  RUN_MASS_ATTACH_LOG[ERROR],
);

export const MASS_ATTACH_FILES = createRequestTypes(
  `${namespace}/MASS_ATTACH_FILES`,
);
export const massAttachFiles = makeApiActionCreatorV3(
  api.massAttachFiles,
  MASS_ATTACH_FILES[START],
  MASS_ATTACH_FILES[SUCCESS],
  MASS_ATTACH_FILES[ERROR],
);

export const MASS_DOWNLOAD_EVIDENCE_PACKETS = createRequestTypes(
  `${namespace}/MASS_DOWNLOAD_EVIDENCE_PACKETS`,
);
export const massDownloadEvidencePackets = makeApiActionCreatorV3(
  api.massDownloadEvidencePackets,
  MASS_DOWNLOAD_EVIDENCE_PACKETS[START],
  MASS_DOWNLOAD_EVIDENCE_PACKETS[SUCCESS],
  MASS_DOWNLOAD_EVIDENCE_PACKETS[ERROR],
);

export const FETCH_APPEAL_MASS_JOB = createRequestTypes(
  `${namespace}/FETCH_APPEAL_MASS_JOB`,
);
export const fetchAppealMassJob = makeApiActionCreatorV3(
  api.fetchAppealMassJob,
  FETCH_APPEAL_MASS_JOB[START],
  FETCH_APPEAL_MASS_JOB[SUCCESS],
  FETCH_APPEAL_MASS_JOB[ERROR],
);

export const UPLOAD_MASS_CREATE_FILES = createRequestTypes(
  `${namespace}/UPLOAD_MASS_CREATE_FILES`,
);
export const uploadMassCreateFiles = makeApiActionCreatorV3(
  api.uploadMassCreateFiles,
  UPLOAD_MASS_CREATE_FILES[START],
  UPLOAD_MASS_CREATE_FILES[SUCCESS],
  UPLOAD_MASS_CREATE_FILES[ERROR],
);

export const DOWNLOAD_MASS_JOB_FILE = createRequestTypes(
  `${namespace}/DOWNLOAD_MASS_JOB_FILE`,
);
export const downloadMassJobFile = makeApiActionCreatorV3(
  api.downloadMassJobFile,
  DOWNLOAD_MASS_JOB_FILE[START],
  DOWNLOAD_MASS_JOB_FILE[SUCCESS],
  DOWNLOAD_MASS_JOB_FILE[ERROR],
);

export const APPEAL_EVENTS_FETCH = createRequestTypes(
  `${namespace}/OWNER/APPEAL_EVENTS_FETCH`,
);

export const fetchAppealEvents = makeApiActionCreatorV3(
  api.fetchAppealEvents,
  APPEAL_EVENTS_FETCH[START],
  APPEAL_EVENTS_FETCH[SUCCESS],
  APPEAL_EVENTS_FETCH[ERROR],
);

export const APPEAL_EVENT_DELETE = createRequestTypes(
  `${namespace}/APPEAL_EVENT_DELETE`,
);
export const deleteAppealEvent = makeApiActionCreatorV3(
  eventApi.deleteEvent,
  APPEAL_EVENT_DELETE[START],
  APPEAL_EVENT_DELETE[SUCCESS],
  APPEAL_EVENT_DELETE[ERROR],
);

export const APPEAL_FETCH_TAXING_UNITS = createRequestTypes(
  `${namespace}/APPEAL_FETCH_TAXING_UNITS`,
);
export const fetchTaxingUnitsSummary = makeApiActionCreatorV3(
  api.fetchTaxingUnitsSummary,
  APPEAL_FETCH_TAXING_UNITS[START],
  APPEAL_FETCH_TAXING_UNITS[SUCCESS],
  APPEAL_FETCH_TAXING_UNITS[ERROR],
);

export const APPEAL_FETCH_CONFIGURATION_GENERAL = createRequestTypes(
  `${namespace}/APPEAL_FETCH_CONFIGURATION_GENERAL`,
);
export const fetchGeneralConfiguration = makeApiActionCreatorV3(
  api.fetchGeneralConfiguration,
  APPEAL_FETCH_CONFIGURATION_GENERAL[START],
  APPEAL_FETCH_CONFIGURATION_GENERAL[SUCCESS],
  APPEAL_FETCH_CONFIGURATION_GENERAL[ERROR],
);

export const APPEAL_UPDATE_CONFIGURATION_GENERAL = createRequestTypes(
  `${namespace}/APPEAL_UPDATE_CONFIGURATION_GENERAL`,
);
export const updateGeneralConfiguration = makeApiActionCreatorV3(
  api.updateGeneralConfiguration,
  APPEAL_UPDATE_CONFIGURATION_GENERAL[START],
  APPEAL_UPDATE_CONFIGURATION_GENERAL[SUCCESS],
  APPEAL_UPDATE_CONFIGURATION_GENERAL[ERROR],
);

export const APPEAL_FETCH_CONFIGURATION_RECOMMENDATIONS = createRequestTypes(
  `${namespace}/APPEAL_FETCH_CONFIGURATION_RECOMMENDATIONS`,
);
export const fetchRecommendationsConfiguration = makeApiActionCreatorV3(
  api.fetchRecommendationsConfiguration,
  APPEAL_FETCH_CONFIGURATION_RECOMMENDATIONS[START],
  APPEAL_FETCH_CONFIGURATION_RECOMMENDATIONS[SUCCESS],
  APPEAL_FETCH_CONFIGURATION_RECOMMENDATIONS[ERROR],
);

export const APPEAL_UPDATE_CONFIGURATION_RECOMMENDATIONS = createRequestTypes(
  `${namespace}/APPEAL_UPDATE_CONFIGURATION_RECOMMENDATIONS`,
);
export const updateRecommendationsConfiguration = makeApiActionCreatorV3(
  api.updateRecommendationsConfiguration,
  APPEAL_UPDATE_CONFIGURATION_RECOMMENDATIONS[START],
  APPEAL_UPDATE_CONFIGURATION_RECOMMENDATIONS[SUCCESS],
  APPEAL_UPDATE_CONFIGURATION_RECOMMENDATIONS[ERROR],
);

export const APPEAL_FETCH_CONFIGURATION_MASS_FINALIZE = createRequestTypes(
  `${namespace}/APPEAL_FETCH_CONFIGURATION_MASS_FINALIZE`,
);
export const fetchMassFinalizeConfiguration = makeApiActionCreatorV3(
  api.fetchMassFinalizeConfiguration,
  APPEAL_FETCH_CONFIGURATION_MASS_FINALIZE[START],
  APPEAL_FETCH_CONFIGURATION_MASS_FINALIZE[SUCCESS],
  APPEAL_FETCH_CONFIGURATION_MASS_FINALIZE[ERROR],
);

export const APPEAL_UPDATE_CONFIGURATION_MASS_FINALIZE = createRequestTypes(
  `${namespace}/APPEAL_UPDATE_CONFIGURATION_MASS_FINALIZE`,
);
export const updateMassFinalizeConfiguration = makeApiActionCreatorV3(
  api.updateMassFinalizeConfiguration,
  APPEAL_UPDATE_CONFIGURATION_MASS_FINALIZE[START],
  APPEAL_UPDATE_CONFIGURATION_MASS_FINALIZE[SUCCESS],
  APPEAL_UPDATE_CONFIGURATION_MASS_FINALIZE[ERROR],
);

export const APPEAL_FETCH_CONFIGURATION_AUTO_GENERATE_PACKET =
  createRequestTypes(
    `${namespace}/APPEAL_FETCH_CONFIGURATION_AUTO_GENERATE_PACKET`,
  );
export const fetchAutoGeneratePacketConfiguration = makeApiActionCreatorV3(
  api.fetchAutoGeneratePacketConfiguration,
  APPEAL_FETCH_CONFIGURATION_AUTO_GENERATE_PACKET[START],
  APPEAL_FETCH_CONFIGURATION_AUTO_GENERATE_PACKET[SUCCESS],
  APPEAL_FETCH_CONFIGURATION_AUTO_GENERATE_PACKET[ERROR],
);

export const APPEAL_UPDATE_CONFIGURATION_AUTO_GENERATE_PACKET =
  createRequestTypes(
    `${namespace}/APPEAL_UPDATE_CONFIGURATION_AUTO_GENERATE_PACKET`,
  );
export const updateAutoGeneratePacketConfiguration = makeApiActionCreatorV3(
  api.updateAutoGeneratePacketConfiguration,
  APPEAL_UPDATE_CONFIGURATION_AUTO_GENERATE_PACKET[START],
  APPEAL_UPDATE_CONFIGURATION_AUTO_GENERATE_PACKET[SUCCESS],
  APPEAL_UPDATE_CONFIGURATION_AUTO_GENERATE_PACKET[ERROR],
);

export const APPEAL_FETCH_CONFIGURATION_AUTO_OFFER = createRequestTypes(
  `${namespace}/APPEAL_FETCH_CONFIGURATION_AUTO_OFFER`,
);
export const fetchAutoOfferConfiguration = makeApiActionCreatorV3(
  api.fetchAutoOfferConfiguration,
  APPEAL_FETCH_CONFIGURATION_AUTO_OFFER[START],
  APPEAL_FETCH_CONFIGURATION_AUTO_OFFER[SUCCESS],
  APPEAL_FETCH_CONFIGURATION_AUTO_OFFER[ERROR],
);

export const APPEAL_UPDATE_CONFIGURATION_AUTO_OFFER = createRequestTypes(
  `${namespace}/APPEAL_UPDATE_CONFIGURATION_AUTO_OFFER`,
);
export const updateAutoOfferConfiguration = makeApiActionCreatorV3(
  api.updateAutoOfferConfiguration,
  APPEAL_UPDATE_CONFIGURATION_AUTO_OFFER[START],
  APPEAL_UPDATE_CONFIGURATION_AUTO_OFFER[SUCCESS],
  APPEAL_UPDATE_CONFIGURATION_AUTO_OFFER[ERROR],
);

export const FETCH_APPEAL_CONFIG_DECISION_SHEET = createRequestTypes(
  `${namespace}/FETCH_APPEAL_CONFIG_DECISION_SHEET`,
);
export const fetchAppealConfigDecisionSheet = makeApiActionCreatorV3(
  api.fetchAppealConfigDecisionSheet,
  FETCH_APPEAL_CONFIG_DECISION_SHEET[START],
  FETCH_APPEAL_CONFIG_DECISION_SHEET[SUCCESS],
  FETCH_APPEAL_CONFIG_DECISION_SHEET[ERROR],
);

export const UPDATE_APPEAL_CONFIG_DECISION_SHEET = createRequestTypes(
  `${namespace}/UPDATE_APPEAL_CONFIG_DECISION_SHEET`,
);
export const updateAppealConfigDecisionSheet = makeApiActionCreatorV3(
  api.updateAppealConfigDecisionSheet,
  UPDATE_APPEAL_CONFIG_DECISION_SHEET[START],
  UPDATE_APPEAL_CONFIG_DECISION_SHEET[SUCCESS],
  UPDATE_APPEAL_CONFIG_DECISION_SHEET[ERROR],
);

export const FETCH_APPEAL_CONFIG_REVISION_HISTORY = createRequestTypes(
  `${namespace}/FETCH_APPEAL_CONFIG_REVISION_HISTORY`,
);
export const fetchAppealConfigRevisionHistory = makeApiActionCreatorV3(
  api.fetchAppealConfigRevisionHistory,
  FETCH_APPEAL_CONFIG_REVISION_HISTORY[START],
  FETCH_APPEAL_CONFIG_REVISION_HISTORY[SUCCESS],
  FETCH_APPEAL_CONFIG_REVISION_HISTORY[ERROR],
);

export const SET_ARRIVAL_TIME = createRequestTypes(
  `${namespace}/SET_ARRIVAL_TIME`,
);
export const setArrivalTime = makeApiActionCreatorV3(
  api.setArrivalTime,
  SET_ARRIVAL_TIME[START],
  SET_ARRIVAL_TIME[SUCCESS],
  SET_ARRIVAL_TIME[ERROR],
);

export const SET_INFORMAL_ARRIVAL_TIME = createRequestTypes(
  `${namespace}/SET_INFORMAL_ARRIVAL_TIME`,
);
export const setInformalArrivalTime = makeApiActionCreatorV3(
  api.setInformalArrivalTime,
  SET_INFORMAL_ARRIVAL_TIME[START],
  SET_INFORMAL_ARRIVAL_TIME[SUCCESS],
  SET_INFORMAL_ARRIVAL_TIME[ERROR],
);

export const FETCH_PROTESTORS = createRequestTypes(
  `${namespace}/FETCH_PROTESTORS`,
);
export const fetchProtestors = makeApiActionCreatorV3(
  api.fetchProtestors,
  FETCH_PROTESTORS[START],
  FETCH_PROTESTORS[SUCCESS],
  FETCH_PROTESTORS[ERROR],
);

export const CREATE_PROTESTOR = createRequestTypes(
  `${namespace}/CREATE_PROTESTOR`,
);
export const createProtestor = makeApiActionCreatorV3(
  api.createProtestor,
  CREATE_PROTESTOR[START],
  CREATE_PROTESTOR[SUCCESS],
  CREATE_PROTESTOR[ERROR],
);

export const UPDATE_PROTESTOR = createRequestTypes(
  `${namespace}/UPDATE_PROTESTOR`,
);
export const updateProtestor = makeApiActionCreatorV3(
  api.updateProtestor,
  UPDATE_PROTESTOR[START],
  UPDATE_PROTESTOR[SUCCESS],
  UPDATE_PROTESTOR[ERROR],
);

export const SET_PRIMARY_PROTESTOR = createRequestTypes(
  `${namespace}/SET_PRIMARY_PROTESTOR`,
);
export const setPrimaryProtestor = makeApiActionCreatorV3(
  api.setPrimaryProtestor,
  SET_PRIMARY_PROTESTOR[START],
  SET_PRIMARY_PROTESTOR[SUCCESS],
  SET_PRIMARY_PROTESTOR[ERROR],
);

export const DELETE_PROTESTOR = createRequestTypes(
  `${namespace}/DELETE_PROTESTOR`,
);
export const deleteProtestor = makeApiActionCreatorV3(
  api.deleteProtestor,
  DELETE_PROTESTOR[START],
  DELETE_PROTESTOR[SUCCESS],
  DELETE_PROTESTOR[ERROR],
);

export const FETCH_PROTESTOR_PORTAL_USERS = createRequestTypes(
  `${namespace}/FETCH_PROTESTOR_PORTAL_USERS`,
);

export const fetchProtestorPortalUsers = makeApiActionCreatorV3(
  api.fetchProtestorPortalUsers,
  FETCH_PROTESTOR_PORTAL_USERS[START],
  FETCH_PROTESTOR_PORTAL_USERS[SUCCESS],
  FETCH_PROTESTOR_PORTAL_USERS[ERROR],
);

export const FETCH_ELECTRONIC_NOTICE_SETTING = createRequestTypes(
  `${namespace}/FETCH_ELECTRONIC_NOTICE_SETTING`,
);

export const fetchElectronicNoticeSetting = makeApiActionCreatorV3(
  api.fetchElectronicNoticeSetting,
  FETCH_ELECTRONIC_NOTICE_SETTING[START],
  FETCH_ELECTRONIC_NOTICE_SETTING[SUCCESS],
  FETCH_ELECTRONIC_NOTICE_SETTING[ERROR],
);

export const FETCH_ELECTRONIC_NOTICE_SETTING_INFORMAL_PRIOR =
  createRequestTypes(
    `${namespace}/FETCH_ELECTRONIC_NOTICE_SETTING_INFORMAL_PRIOR`,
  );

export const fetchElectronicNoticeSettingInformalPrior = makeApiActionCreatorV3(
  api.fetchElectronicNoticeSettingInformalPrior,
  FETCH_ELECTRONIC_NOTICE_SETTING_INFORMAL_PRIOR[START],
  FETCH_ELECTRONIC_NOTICE_SETTING_INFORMAL_PRIOR[SUCCESS],
  FETCH_ELECTRONIC_NOTICE_SETTING_INFORMAL_PRIOR[ERROR],
);

export const FETCH_ELECTRONIC_NOTICE_SETTING_INFORMAL_SAME_DAY =
  createRequestTypes(
    `${namespace}/FETCH_ELECTRONIC_NOTICE_SETTING_INFORMAL_SAME_DAY`,
  );

export const fetchElectronicNoticeSettingInformalSameDay =
  makeApiActionCreatorV3(
    api.fetchElectronicNoticeSettingInformalSameDay,
    FETCH_ELECTRONIC_NOTICE_SETTING_INFORMAL_SAME_DAY[START],
    FETCH_ELECTRONIC_NOTICE_SETTING_INFORMAL_SAME_DAY[SUCCESS],
    FETCH_ELECTRONIC_NOTICE_SETTING_INFORMAL_SAME_DAY[ERROR],
  );

export const UPDATE_ELECTRONIC_NOTICE_SETTING_INFORMAL_PRIOR =
  createRequestTypes(
    `${namespace}/UPDATE_ELECTRONIC_NOTICE_SETTING_INFORMAL_PRIOR`,
  );

export const updateElectronicNoticeSettingInformalPrior =
  makeApiActionCreatorV3(
    api.updateElectronicNoticeSettingInformalPrior,
    UPDATE_ELECTRONIC_NOTICE_SETTING_INFORMAL_PRIOR[START],
    UPDATE_ELECTRONIC_NOTICE_SETTING_INFORMAL_PRIOR[SUCCESS],
    UPDATE_ELECTRONIC_NOTICE_SETTING_INFORMAL_PRIOR[ERROR],
  );

export const UPDATE_ELECTRONIC_NOTICE_SETTING_INFORMAL_SAME_DAY =
  createRequestTypes(
    `${namespace}/UPDATE_ELECTRONIC_NOTICE_SETTING_INFORMAL_SAME_DAY`,
  );

export const updateElectronicNoticeSettingInformalSameDay =
  makeApiActionCreatorV3(
    api.updateElectronicNoticeSettingInformalSameDay,
    UPDATE_ELECTRONIC_NOTICE_SETTING_INFORMAL_SAME_DAY[START],
    UPDATE_ELECTRONIC_NOTICE_SETTING_INFORMAL_SAME_DAY[SUCCESS],
    UPDATE_ELECTRONIC_NOTICE_SETTING_INFORMAL_SAME_DAY[ERROR],
  );

export const FETCH_ELECTRONIC_HEARING_TAGS = createRequestTypes(
  `${namespace}/FETCH_ELECTRONIC_HEARING_TAGS`,
);

export const fetchElectronicHearingTags = makeApiActionCreatorV3(
  api.fetchElectronicHearingTags,
  FETCH_ELECTRONIC_HEARING_TAGS[START],
  FETCH_ELECTRONIC_HEARING_TAGS[SUCCESS],
  FETCH_ELECTRONIC_HEARING_TAGS[ERROR],
);

export const UPDATE_ELECTRONIC_NOTICE_SETTING = createRequestTypes(
  `${namespace}/UPDATE_ELECTRONIC_NOTICE_SETTING`,
);

export const updateElectronicNoticeSetting = makeApiActionCreatorV3(
  api.updateElectronicNoticeSetting,
  UPDATE_ELECTRONIC_NOTICE_SETTING[START],
  UPDATE_ELECTRONIC_NOTICE_SETTING[SUCCESS],
  UPDATE_ELECTRONIC_NOTICE_SETTING[ERROR],
);

export const CREATE_ELECTRONIC_NOTICE_START_RUN = createRequestTypes(
  `${namespace}/CREATE_ELECTRONIC_NOTICE_START_RUN`,
);

export const createElectronicNoticeStartRun = makeApiActionCreatorV3(
  api.createElectronicNoticeStartRun,
  CREATE_ELECTRONIC_NOTICE_START_RUN[START],
  CREATE_ELECTRONIC_NOTICE_START_RUN[SUCCESS],
  CREATE_ELECTRONIC_NOTICE_START_RUN[ERROR],
);

export const CREATE_MASS_AOA_SUBMIT = createRequestTypes(
  `${namespace}/CREATE_MASS_AOA_SUBMIT`,
);

export const createMassAoaSubmit = makeApiActionCreatorV3(
  api.createMassAoaSubmit,
  CREATE_MASS_AOA_SUBMIT[START],
  CREATE_MASS_AOA_SUBMIT[SUCCESS],
  CREATE_MASS_AOA_SUBMIT[ERROR],
);

export const CREATE_MASS_AOA_REVOKE = createRequestTypes(
  `${namespace}/CREATE_MASS_AOA_REVOKE`,
);

export const createMassAoaRevoke = makeApiActionCreatorV3(
  api.createMassAoaRevoke,
  CREATE_MASS_AOA_REVOKE[START],
  CREATE_MASS_AOA_REVOKE[SUCCESS],
  CREATE_MASS_AOA_REVOKE[ERROR],
);

export const UPLOAD_AGENT_FILES = createRequestTypes(
  `${namespace}/UPLOAD_AGENT_FILES`,
);

export const uploadAgentFiles = makeApiActionCreatorV3(
  api.uploadAgentFiles,
  UPLOAD_AGENT_FILES[START],
  UPLOAD_AGENT_FILES[SUCCESS],
  UPLOAD_AGENT_FILES[ERROR],
);

export const SET_SEARCH_MODIFIER = `${namespace}/SET_SEARCH_MODIFIER`;

export function setSearchModifier(data) {
  return async (dispatch) => {
    dispatch({ type: SET_SEARCH_MODIFIER, data: data });
  };
}
export const DELETE_PRESENTATION_DOCUMENTS = createRequestTypes(
  `${namespace}/DELETE_PRESENTATION_DOCUMENTS`,
);

export const deletePresentationDocuments = makeApiActionCreatorV3(
  api.deletePresentationDocuments,
  DELETE_PRESENTATION_DOCUMENTS[START],
  DELETE_PRESENTATION_DOCUMENTS[SUCCESS],
  DELETE_PRESENTATION_DOCUMENTS[ERROR],
);

export const FETCH_PANEL_DOCKET_GROUPS = createRequestTypes(
  `${namespace}/FETCH_PANEL_DOCKET_GROUPS`,
);

export const fetchPanelDocketGroups = makeApiActionCreatorV3(
  api.fetchPanelDocketGroups,
  FETCH_PANEL_DOCKET_GROUPS[START],
  FETCH_PANEL_DOCKET_GROUPS[SUCCESS],
  FETCH_PANEL_DOCKET_GROUPS[ERROR],
);

export const DELETE_PANEL_DOCKET_GROUPS = createRequestTypes(
  `${namespace}/DELETE_PANEL_DOCKET_GROUPS`,
);

export const deletePanelDocketGroups = makeApiActionCreatorV3(
  api.deletePanelDocketGroups,
  DELETE_PANEL_DOCKET_GROUPS[START],
  DELETE_PANEL_DOCKET_GROUPS[SUCCESS],
  DELETE_PANEL_DOCKET_GROUPS[ERROR],
);

export const CREATE_PANEL_DOCKET_GROUP = createRequestTypes(
  `${namespace}/CREATE_PANEL_DOCKET_GROUP`,
);

export const createPanelDocketGroup = makeApiActionCreatorV3(
  api.createPanelDocketGroup,
  CREATE_PANEL_DOCKET_GROUP[START],
  CREATE_PANEL_DOCKET_GROUP[SUCCESS],
  CREATE_PANEL_DOCKET_GROUP[ERROR],
);

export const DELETE_PANEL_DOCKET_GROUP = createRequestTypes(
  `${namespace}/DELETE_PANEL_DOCKET_GROUP`,
);

export const deletePanelDocketGroup = makeApiActionCreatorV3(
  api.deletePanelDocketGroup,
  DELETE_PANEL_DOCKET_GROUP[START],
  DELETE_PANEL_DOCKET_GROUP[SUCCESS],
  DELETE_PANEL_DOCKET_GROUP[ERROR],
);

export const APPEAL_SET_SEARCH_FORM_DATA = `${namespace}/APPEAL_SET_SEARCH_FORM_DATA`;
export const setAppealFormData = (formData) => ({
  type: APPEAL_SET_SEARCH_FORM_DATA,
  payload: formData,
});

export const FETCH_PANEL_WAITING_ROOMS = createRequestTypes(
  `${namespace}/FETCH_PANEL_WAITING_ROOMS`,
);

export const fetchPanelWaitingRooms = makeApiActionCreatorV3(
  api.fetchPanelWaitingRooms,
  FETCH_PANEL_WAITING_ROOMS[START],
  FETCH_PANEL_WAITING_ROOMS[SUCCESS],
  FETCH_PANEL_WAITING_ROOMS[ERROR],
);

export const DELETE_PANEL_WAITING_ROOMS = createRequestTypes(
  `${namespace}/DELETE_PANEL_WAITING_ROOMS`,
);

export const deletePanelWaitingRooms = makeApiActionCreatorV3(
  api.deletePanelWaitingRooms,
  DELETE_PANEL_WAITING_ROOMS[START],
  DELETE_PANEL_WAITING_ROOMS[SUCCESS],
  DELETE_PANEL_WAITING_ROOMS[ERROR],
);
export const ADD_PANEL_WAITING_ROOM = createRequestTypes(
  `${namespace}/ADD_PANEL_WAITING_ROOM`,
);

export const addPanelWaitingRoom = makeApiActionCreatorV3(
  api.addPanelWaitingRoom,
  ADD_PANEL_WAITING_ROOM[START],
  ADD_PANEL_WAITING_ROOM[SUCCESS],
  ADD_PANEL_WAITING_ROOM[ERROR],
);

export const DELETE_PANEL_WAITING_ROOM = createRequestTypes(
  `${namespace}/DELETE_PANEL_WAITING_ROOM`,
);

export const deletePanelWaitingRoom = makeApiActionCreatorV3(
  api.deletePanelWaitingRoom,
  DELETE_PANEL_WAITING_ROOM[START],
  DELETE_PANEL_WAITING_ROOM[SUCCESS],
  DELETE_PANEL_WAITING_ROOM[ERROR],
);

export const SET_SELECTED_INFORMAL_WAITING_ROOM = `${namespace}/SET_SELECTED_INFORMAL_WAITING_ROOM`;

export const setSelectedInformalWaitingRoom = (waitingRoom) => ({
  type: SET_SELECTED_INFORMAL_WAITING_ROOM,
  payload: waitingRoom,
});

export const CLEAR_SELECTED_INFORMAL_WAITING_ROOM = `${namespace}/CLEAR_SELECTED_INFORMAL_WAITING_ROOM`;

export const clearSelectedInformalWaitingRoom = () => ({
  type: CLEAR_SELECTED_INFORMAL_WAITING_ROOM,
});

export const SET_SELECTED_FORMAL_WAITING_ROOM = `${namespace}/SET_SELECTED_FORMAL_WAITING_ROOM`;

export const setSelectedFormalWaitingRoom = (waitingRoom) => ({
  type: SET_SELECTED_FORMAL_WAITING_ROOM,
  payload: waitingRoom,
});

export const CLEAR_SELECTED_FORMAL_WAITING_ROOM = `${namespace}/CLEAR_SELECTED_FORMAL_WAITING_ROOM`;

export const clearSelectedFormalWaitingRoom = () => ({
  type: CLEAR_SELECTED_FORMAL_WAITING_ROOM,
});

export const SET_SELECTED_PANEL_TYPE = `${namespace}/SET_SELECTED_PANEL_TYPE`;

export const setSelectedPaneltype = (waitingRoom) => ({
  type: SET_SELECTED_PANEL_TYPE,
  payload: waitingRoom,
});

export const CLEAR_SELECTED_PANEL_TYPE = `${namespace}/CLEAR_SELECTED_PANEL_TYPE`;

export const clearSelectedPanelType = () => ({
  type: CLEAR_SELECTED_PANEL_TYPE,
});

export const FETCH_MASS_PROCESS_DETAIL_LIST = createRequestTypes(
  `${namespace}/FETCH_MASS_PROCESS_DETAIL_LIST`,
);

export const fetchMassProcessDetailList = makeApiActionCreatorV3(
  api.fetchMassProcessDetailList,
  FETCH_MASS_PROCESS_DETAIL_LIST[START],
  FETCH_MASS_PROCESS_DETAIL_LIST[SUCCESS],
  FETCH_MASS_PROCESS_DETAIL_LIST[ERROR],
);

export const FETCH_MASS_PROCESS_PROPERTY_LIST = createRequestTypes(
  `${namespace}/FETCH_MASS_PROCESS_PROPERTY_LIST`,
);

export const fetchMassProcessPropertyList = makeApiActionCreatorV3(
  api.fetchMassProcessPropertyList,
  FETCH_MASS_PROCESS_PROPERTY_LIST[START],
  FETCH_MASS_PROCESS_PROPERTY_LIST[SUCCESS],
  FETCH_MASS_PROCESS_PROPERTY_LIST[ERROR],
);

export const FETCH_MASS_PROCESS_ERRORS = createRequestTypes(
  `${namespace}/FETCH_MASS_PROCESS_ERRORS`,
);

export const fetchMassProcessErrors = makeApiActionCreatorV3(
  api.fetchMassProcessErrors,
  FETCH_MASS_PROCESS_ERRORS[START],
  FETCH_MASS_PROCESS_ERRORS[SUCCESS],
  FETCH_MASS_PROCESS_ERRORS[ERROR],
);

export const FETCH_FORMAL_VC_RECORDINGS = createRequestTypes(
  `${namespace}/FETCH_FORMAL_VC_RECORDINGS`,
);

export const fetchFormalVCRecordings = makeApiActionCreatorV3(
  api.fetchFormalVCRecordings,
  FETCH_FORMAL_VC_RECORDINGS[START],
  FETCH_FORMAL_VC_RECORDINGS[SUCCESS],
  FETCH_FORMAL_VC_RECORDINGS[ERROR],
);

export const VALIDATE_APPEAL_IDS_FORMAL_HEARING = createRequestTypes(
  `${namespace}/VALIDATE_APPEAL_IDS_FORMAL_HEARING`,
);

export const validateAppealIDsFormalHearing = makeApiActionCreatorV3(
  api.validateAppealIDsFormalHearing,
  VALIDATE_APPEAL_IDS_FORMAL_HEARING[START],
  VALIDATE_APPEAL_IDS_FORMAL_HEARING[SUCCESS],
  VALIDATE_APPEAL_IDS_FORMAL_HEARING[ERROR],
);

export const VALIDATE_PIDS_FORMAL_HEARING = createRequestTypes(
  `${namespace}/VALIDATE_PIDS_FORMAL_HEARING`,
);

export const validatePIDsFormalHearing = makeApiActionCreatorV3(
  api.validatePIDsFormalHearing,
  VALIDATE_PIDS_FORMAL_HEARING[START],
  VALIDATE_PIDS_FORMAL_HEARING[SUCCESS],
  VALIDATE_PIDS_FORMAL_HEARING[ERROR],
);

export const COPY_FORMAL_HEARINGS_TO = createRequestTypes(
  `${namespace}/COPY_FORMAL_HEARINGS_TO`,
);

export const copyFormalHearingsTo = makeApiActionCreatorV3(
  api.copyFormalHearingsTo,
  COPY_FORMAL_HEARINGS_TO[START],
  COPY_FORMAL_HEARINGS_TO[SUCCESS],
  COPY_FORMAL_HEARINGS_TO[ERROR],
);

export const COPY_FORMAL_HEARINGS_FROM = createRequestTypes(
  `${namespace}/COPY_FORMAL_HEARINGS_FROM`,
);

export const copyFormalHearingsFrom = makeApiActionCreatorV3(
  api.copyFormalHearingsFrom,
  COPY_FORMAL_HEARINGS_FROM[START],
  COPY_FORMAL_HEARINGS_FROM[SUCCESS],
  COPY_FORMAL_HEARINGS_FROM[ERROR],
);

export const MASS_PROCESS_ERRORS_RESET = `${namespace}/MASS_PROCESS_ERRORS_RESET`;

export const resetMassProcessErrors = () => ({
  type: MASS_PROCESS_ERRORS_RESET,
});

export const MASS_PROCESS_PROPERTY_LIST_RESET = `${namespace}/MASS_PROCESS_PROPERTY_LIST_RESET`;

export const resetMassProcessPropertyList = () => ({
  type: MASS_PROCESS_PROPERTY_LIST_RESET,
});

export const FETCH_AGENT_MASS_DOWNLOAD_CONFIG = createRequestTypes(
  `${namespace}/FETCH_AGENT_MASS_DOWNLOAD_CONFIG`,
);
export const fetchAgentMassDownloadConfiguration = makeApiActionCreatorV3(
  api.fetchAgentMassDownloadConfiguration,
  FETCH_AGENT_MASS_DOWNLOAD_CONFIG[START],
  FETCH_AGENT_MASS_DOWNLOAD_CONFIG[SUCCESS],
  FETCH_AGENT_MASS_DOWNLOAD_CONFIG[ERROR],
);
